/**
 * Frame Configurator — Theme-native Konfigurator
 * Phase 0 POC: VariantIndex build, SVG preview, PP/size/price, ATC
 *
 * Dependencies: frame-preview-svg.js (must load before this)
 */
(function () {
  'use strict';

  /* ===================================================================
   * CONSTANTS — ported from custom-frame.tsx
   * =================================================================== */

  var CM_SIZE_THRESHOLDS = [
    48, 56, 64, 72, 80, 88, 96, 104, 112, 120,
    128, 136, 144, 152, 160, 168, 176, 184, 192, 200,
    208, 216, 224, 232, 240, 248, 256, 264, 272, 280,
    288, 296, 304, 312, 320, 328, 336, 344, 352, 360,
    368, 376, 384, 392, 400
  ];

  var PRESET_PASSPARTOUT_DIMENSIONS = {
    thin:     { top: 3.5, bottom: 4,   leftRight: 3.5 },
    standard: { top: 5.5, bottom: 6,   leftRight: 5.5 },
    wide:     { top: 8.5, bottom: 9,   leftRight: 8.5 }
  };

  var SHARED_MAT_COLOR_OPTIONS = [
    { color: 'naturweiss', displayName: 'Naturwei\u00DF', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Naturweiss_MSK-Naturweiss.png?v=1754908103' },
    { color: 'hellweiss', displayName: 'Hellwei\u00DF', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hellweiss_MSK-Hellweiss.png?v=1754908062' },
    { color: 'creme', displayName: 'Creme', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Creme_MSK-Creme.png?v=1754908112' },
    { color: 'schwarz', displayName: 'Schwarz', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Schwarz_MSK-Schwarz.png?v=1754908109' },
    { color: 'hellgrau', displayName: 'Hellgrau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hell-Grau_8159.png?v=1754908118' },
    { color: 'dunkelgrau', displayName: 'Dunkelgrau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Grau_8010.png?v=1754908119' },
    { color: 'beige', displayName: 'Beige', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Beige_8009.png?v=1754908118' },
    { color: 'braun', displayName: 'Braun', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Braun_8023.png?v=1754908118' },
    { color: 'dunkelbraun', displayName: 'Dunkelbraun', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Braun_8007.png?v=1754908118' },
    { color: 'babyblau', displayName: 'Babyblau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Baby-Blau_8051.png?v=1754908031' },
    { color: 'blau', displayName: 'Blau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Blau_8054.png?v=1754908118' },
    { color: 'dunkelblau', displayName: 'Dunkelblau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Blau_8686.png?v=1754908118' },
    { color: 'hellgruen', displayName: 'Hellgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hell-Gruen_8017.png?v=1754908118' },
    { color: 'beigegruen', displayName: 'Beigegr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Beige_Gruen_8030.png?v=1754908118' },
    { color: 'olivgruen', displayName: 'Olivgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Oliv-Gruen_8034.png?v=1754908118' },
    { color: 'dunkelgruen', displayName: 'Dunkelgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Gruen_8018.png?v=1754908119' },
    { color: 'rosa', displayName: 'Rosa', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Rosa_8064.png?v=1754908118' },
    { color: 'pink', displayName: 'Pink', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Pink_8028.png?v=1754908118' },
    { color: 'rot', displayName: 'Rot', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Rot_8699.png?v=1754908118' },
    { color: 'kirsch', displayName: 'Kirsch', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Kirsch-Rot_8151.png?v=1754908118' },
    { color: 'wein', displayName: 'Wein', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Wein-Rot_8016.png?v=1754908118' },
    { color: 'gelb', displayName: 'Gelb', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Gelb_8695.png?v=1754903609' }
  ];

  var CART_SVG_STORAGE_KEY = 'framelin-cart-svg-render-data-v1';
  var CART_SVG_STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  /* ===================================================================
   * TYPE CARD ORDERING
   * =================================================================== */

  /** Canonical display order for frame type cards (normalized, lowercase, no parens). */
  var TYPE_CARD_ORDER = [
    'digitaler upload',
    'digitale leinwand',
    'papierarbeit',
    'leinwand nicht aufgespannt',
    'leinwand aufgespannt'
  ];

  var PAPER_TYPE_KEYS = ['digitaler upload', 'papierarbeit'];
  var CANVAS_TYPE_KEYS = ['digitale leinwand', 'leinwand nicht aufgespannt', 'leinwand aufgespannt'];

  function classifyProductTypes(typeValues) {
    var hasPaper = false, hasCanvas = false;
    for (var i = 0; i < typeValues.length; i++) {
      var nk = normalizeTypeKey(typeValues[i]);
      if (PAPER_TYPE_KEYS.indexOf(nk) !== -1) hasPaper = true;
      if (CANVAS_TYPE_KEYS.indexOf(nk) !== -1) hasCanvas = true;
    }
    if (hasPaper && hasCanvas) return 'full';
    if (hasPaper) return 'paper-only';
    if (hasCanvas) return 'canvas-only';
    return 'unknown';
  }

  /** Normalize a type value for ordering: lowercase, strip parens, collapse whitespace. */
  function normalizeTypeKey(raw) {
    return (raw || '').toLowerCase().replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
  }

  /** Sort type values array according to TYPE_CARD_ORDER. Unknown types go last. */
  function sortTypeValues(arr) {
    return arr.slice().sort(function (a, b) {
      var ia = TYPE_CARD_ORDER.indexOf(normalizeTypeKey(a));
      var ib = TYPE_CARD_ORDER.indexOf(normalizeTypeKey(b));
      if (ia === -1) ia = 999;
      if (ib === -1) ib = 999;
      return ia - ib;
    });
  }

  /* ===================================================================
   * UTILITIES
   * =================================================================== */

  function getUmfangSizeLabel(umfang) {
    for (var i = 0; i < CM_SIZE_THRESHOLDS.length; i++) {
      if (umfang <= CM_SIZE_THRESHOLDS[i]) return 'bis ' + CM_SIZE_THRESHOLDS[i] + ' cm';
    }
    return 'bis ' + CM_SIZE_THRESHOLDS[CM_SIZE_THRESHOLDS.length - 1] + ' cm';
  }

  /**
   * Normalize a PP type value to canonical form.
   * Canonical: 'ohne', 'einfach', 'freigestellt'
   */
  function normalizePPType(raw) {
    var val = (raw || '').toLowerCase().trim();
    if (val === 'standard' || val === 'normal' || val === 'aufgelegt') return 'einfach';
    if (val === 'innenliegend' || val === 'innenligend' || val === 'inner') return 'freigestellt';
    if (val === 'without' || val === 'none' || val === 'kein' || val === 'keine') return 'ohne';
    if (val === '' || val === 'ohne') return 'ohne';
    return val; // 'einfach', 'freigestellt' pass through
  }

  /**
   * Normalize a size key to canonical "bis X cm" format.
   * Handles variations like "bis 144cm", "Bis 144 cm", " bis  144  cm ".
   */
  function normalizeSizeKey(raw) {
    var val = (raw || '').toLowerCase().trim();
    var match = val.match(/^bis\s+(\d+)\s*cm$/);
    if (match) {
      return 'bis ' + match[1] + ' cm';
    }
    return val;
  }

  /**
   * Build VariantIndex from Liquid-provided variant array.
   * Prefers variant.options array (from Liquid), falls back to title parsing.
   * Variant title format: "Typ / Gr\u00f6\u00dfe / Passepartout"
   * Variant options format: ["Leonardo", "bis 144 cm", "Ohne"]
   * Returns: { frameType: { sizeLabel: { ppType: { id, price } } } }
   * If no frame type option exists, uses '_default' as key.
   */
  function buildVariantIndex(variants) {
    var index = {};
    var parsed = 0;
    var skipped = 0;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var typeValue = '_default';
      var sizeValue = '';
      var ppValue = '';

      // Strategy 1: Use options array (most reliable — from Liquid variant.options)
      if (v.options && Array.isArray(v.options) && v.options.length >= 2) {
        if (v.options.length >= 3) {
          // 3 options: [Typ, Gr\u00f6\u00dfe, Passepartout]
          typeValue = (v.options[0] || '').trim();
          sizeValue = (v.options[1] || '').toLowerCase().trim();
          ppValue = (v.options[2] || '').toLowerCase().trim();
        } else if (v.options.length === 2) {
          // 2 options: [Gr\u00f6\u00dfe, Passepartout]
          sizeValue = (v.options[0] || '').toLowerCase().trim();
          ppValue = (v.options[1] || '').toLowerCase().trim();
        }
      }

      // Strategy 2: Fallback to title parsing
      if (!sizeValue) {
        var title = (v.title || '').toLowerCase();
        var parts = title.split('/').map(function (s) { return s.trim(); });

        if (parts.length >= 3) {
          typeValue = parts[0];
          sizeValue = parts[1];
          ppValue = parts[2];
        } else if (parts.length === 2) {
          sizeValue = parts[0];
          ppValue = parts[1];
        }
      }

      if (!sizeValue) {
        console.warn('[FrameConfigurator] Skipped variant (no size):', v.title, '| options:', JSON.stringify(v.options));
        skipped++;
        continue;
      }

      // Normalize keys at index-build time
      sizeValue = normalizeSizeKey(sizeValue);
      ppValue = normalizePPType(ppValue);

      if (!index[typeValue]) {
        index[typeValue] = {};
      }
      if (!index[typeValue][sizeValue]) {
        index[typeValue][sizeValue] = {};
      }
      index[typeValue][sizeValue][ppValue] = {
        id: v.id,
        price: v.price / 100 // Liquid price is in cents
      };
      parsed++;
    }

    var typeKeys = Object.keys(index);
    console.log('[FrameConfigurator] VariantIndex built:', parsed, 'variants parsed,', skipped, 'skipped. Types:', typeKeys.join(', '));
    return index;
  }

  /**
   * Fetch ALL variants for a product via Shopify Storefront API (GraphQL).
   * Uses cursor-based pagination to bypass the 250-variant Liquid/REST limit.
   * Returns a Promise resolving to an array in the same format as Liquid variants:
   * { id: Number, price: Number (cents), options: [String, String, ...] }
   */
  function fetchAllVariantsViaStorefrontAPI(productId, token, apiVersion) {
    if (!token) return Promise.reject(new Error('No Storefront API token'));

    var gid = String(productId);
    if (gid.indexOf('gid://') !== 0) gid = 'gid://shopify/Product/' + gid;

    var shopDomain = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    var endpoint = 'https://' + shopDomain + '/api/' + (apiVersion || '2024-10') + '/graphql.json';
    var allVariants = [];

    function fetchPage(cursor) {
      var afterClause = cursor ? ', after: "' + cursor + '"' : '';
      var query = '{ product(id: "' + gid + '") {'
        + ' variants(first: 250' + afterClause + ') {'
        + '  edges { cursor node { id price { amount } selectedOptions { name value } } }'
        + '  pageInfo { hasNextPage }'
        + ' }'
        + '} }';

      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query })
      })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.errors) {
          console.error('[FrameConfigurator] Storefront API errors:', json.errors);
          throw new Error(json.errors[0].message);
        }
        if (!json.data || !json.data.product) {
          throw new Error('Product not found in Storefront API');
        }
        var variants = json.data.product.variants;
        var edges = variants.edges;

        for (var i = 0; i < edges.length; i++) {
          var node = edges[i].node;
          var numericId = parseInt(node.id.split('/').pop(), 10);
          var options = [];
          for (var j = 0; j < node.selectedOptions.length; j++) {
            options.push(node.selectedOptions[j].value);
          }
          var priceInCents = Math.round(parseFloat(node.price.amount) * 100);
          allVariants.push({ id: numericId, price: priceInCents, options: options });
        }

        if (variants.pageInfo.hasNextPage && edges.length > 0) {
          return fetchPage(edges[edges.length - 1].cursor);
        }
        return allVariants;
      });
    }

    return fetchPage(null);
  }

  function getSizeCategory(imageWidth, imageHeight, matWidth, frameWidthMM, ppType, individualSizes) {
    var isNoPP = ppType === 'ohne' || matWidth === 'ohne';
    var matTopCM = 0, matBottomCM = 0, matLeftRightCM = 0;

    if (!isNoPP) {
      if (matWidth === 'individual' && individualSizes) {
        matTopCM = individualSizes.top || 0;
        matBottomCM = individualSizes.bottom || 0;
        matLeftRightCM = individualSizes.leftRight || 0;
      } else {
        var preset = PRESET_PASSPARTOUT_DIMENSIONS[matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
        matTopCM = preset.top;
        matBottomCM = preset.bottom;
        matLeftRightCM = preset.leftRight;
      }
    }

    var falzWidth = isNoPP ? imageWidth : imageWidth + 2 * matLeftRightCM;
    var falzHeight = isNoPP ? imageHeight : imageHeight + matTopCM + matBottomCM;
    var falzmass = 2 * (falzWidth + falzHeight);

    return getUmfangSizeLabel(falzmass);
  }

  function lookupVariant(variantIndex, frameType, sizeCategory, ppType) {
    var typeMap = variantIndex[frameType];
    if (!typeMap) return null;

    var sizeKey = normalizeSizeKey(sizeCategory);
    var ppKey = normalizePPType(ppType);

    var sizeMap = typeMap[sizeKey];
    if (!sizeMap) return null;

    if (sizeMap[ppKey]) return sizeMap[ppKey];

    // Fallback: ohne
    if (sizeMap['ohne']) return sizeMap['ohne'];
    return null;
  }

  /**
   * Analyse why a variant is unavailable and return a helpful customer-facing hint.
   * Returns null when no hint is needed (variant exists or type is lazy-loading).
   */
  function getVariantHint(vIndex, frameType, sizeCategory, ppType,
                          imgW, imgH, frameBreiteMM) {
    var typeMap = vIndex[frameType];
    if (!typeMap) return null; // Lazy loading → "Lade Preise…" handles this

    var sizeKey = normalizeSizeKey(sizeCategory);
    var ppKey = normalizePPType(ppType);
    var sizeMap = typeMap[sizeKey];

    // Size exists but neither PP type nor "ohne" available → rare edge case
    if (sizeMap && !sizeMap[ppKey] && !sizeMap['ohne']) {
      return 'Diese Kombination ist leider nicht verf\u00fcgbar.';
    }

    // Size doesn't exist → find max available size for this type
    if (!sizeMap) {
      var maxSizeNum = 0;
      var allSizeKeys = Object.keys(typeMap);
      for (var i = 0; i < allSizeKeys.length; i++) {
        var m = allSizeKeys[i].match(/(\d+)/);
        if (m) {
          var n = parseInt(m[1], 10);
          if (n > maxSizeNum) maxSizeNum = n;
        }
      }

      // If PP is active: check whether "ohne" would fit → suggest reducing PP
      if (ppKey !== 'ohne') {
        var cW = Math.max(10, Math.min(110, imgW));
        var cH = Math.max(10, Math.min(110, imgH));
        var sizeCatOhne = getSizeCategory(cW, cH, 'ohne', frameBreiteMM, 'ohne', null);
        var sizeKeyOhne = normalizeSizeKey(sizeCatOhne);
        if (typeMap[sizeKeyOhne]) {
          return 'In dieser Gr\u00f6\u00dfe mit Passepartout leider nicht verf\u00fcgbar (max. '
            + maxSizeNum + ' cm Umfang). W\u00e4hle ein schmaleres Passepartout oder \u201eOhne\u201c.';
        }
      }

      // Even without PP it's too large
      return 'Leider nicht in dieser Gr\u00f6\u00dfe verf\u00fcgbar. Maximal bis '
        + maxSizeNum + ' cm Umfang verf\u00fcgbar. Bitte w\u00e4hle kleinere Ma\u00dfe.';
    }

    return null; // Variant exists, no hint needed
  }

  function formatPriceFromEuros(euros) {
    return euros.toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function addBusinessDays(fromDate, days) {
    var d = new Date(fromDate);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatDateRange(startDate, endDate) {
    var months = ['Januar','Februar','M\u00E4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    if (startDate.getMonth() === endDate.getMonth()) {
      return startDate.getDate() + '. \u2013 ' + endDate.getDate() + '. ' + months[endDate.getMonth()] + ' ' + endDate.getFullYear();
    }
    return startDate.getDate() + '. ' + months[startDate.getMonth()] + ' \u2013 ' + endDate.getDate() + '. ' + months[endDate.getMonth()] + ' ' + endDate.getFullYear();
  }

  function formatSingleDate(d) {
    var months = ['Januar','Februar','M\u00E4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    return d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function getDeliveryEstimate(isSendIn) {
    var deliveryConfig = { min: 7, max: 10 };
    try {
      var el = document.getElementById('frame-delivery-config');
      if (el) deliveryConfig = JSON.parse(el.textContent);
    } catch (e) {}
    var now = new Date();
    var minDays = deliveryConfig.min || 7;
    var maxDays = deliveryConfig.max || 10;

    if (isSendIn) {
      // Send-in: customer sends art within 3 business days, then we need 7-10 Werktage after receiving
      var sendByDate = addBusinessDays(now, 3);
      var deliveryStart = addBusinessDays(sendByDate, minDays);
      var deliveryEnd = addBusinessDays(sendByDate, maxDays);
      return {
        headline: 'Voraussichtliche Lieferung: ' + formatDateRange(deliveryStart, deliveryEnd),
        sendin: 'Sende uns dein Bild bis ' + formatSingleDate(sendByDate) + ' \u2013 wir rahmen es in ' + minDays + '\u2013' + maxDays + ' Werktagen'
      };
    }

    // Digital types: straightforward delivery estimate
    var start = addBusinessDays(now, minDays);
    var end = addBusinessDays(now, maxDays);
    return {
      headline: 'Voraussichtliche Lieferung: ' + formatDateRange(start, end),
      sendin: null
    };
  }

  function getMatPresetDescription(key) {
    var preset = PRESET_PASSPARTOUT_DIMENSIONS[key];
    if (!preset) return '';
    if (preset.top === preset.bottom && preset.top === preset.leftRight) {
      return preset.top + ' cm';
    }
    return preset.top + ' / ' + preset.bottom + ' / ' + preset.leftRight + ' cm';
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function persistCartSvgRenderData(lineItemKey, data) {
    try {
      var raw = localStorage.getItem(CART_SVG_STORAGE_KEY);
      var store = raw ? JSON.parse(raw) : {};
      var now = Date.now();
      Object.keys(store).forEach(function (key) {
        if (now - (store[key].updatedAt || 0) > CART_SVG_STORAGE_TTL_MS) delete store[key];
      });
      store[lineItemKey] = { updatedAt: now, data: data };
      localStorage.setItem(CART_SVG_STORAGE_KEY, JSON.stringify(store));
    } catch (e) {
      try {
        sessionStorage.setItem(CART_SVG_STORAGE_KEY, JSON.stringify({
          [lineItemKey]: { updatedAt: Date.now(), data: data }
        }));
      } catch (_) { /* ignore */ }
    }
  }

  /* ===================================================================
   * MAIN CONFIGURATOR
   * =================================================================== */

  function init() {
    var dataEl = document.getElementById('frame-product-data');
    if (!dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[FrameConfigurator] Failed to parse product data:', e);
      return;
    }

    console.log('[FrameConfigurator] Product data loaded:', productData.title, '| Variants:', productData.variants.length, '| FrameLR:', productData.frameImageLR ? 'SET' : 'EMPTY', '| FrameTB:', productData.frameImageTB ? 'SET' : 'EMPTY');

    // Merge admin-configured type card label overrides
    var typeCardSettingsEl = document.getElementById('frame-type-card-settings');
    if (typeCardSettingsEl) {
      try {
        var overrides = JSON.parse(typeCardSettingsEl.textContent);
        for (var key in overrides) {
          if (overrides.hasOwnProperty(key)) {
            var ov = overrides[key];
            if (ov.title || ov.desc) {
              if (!TYPE_CARD_META[key]) TYPE_CARD_META[key] = {};
              if (ov.title) TYPE_CARD_META[key].title = ov.title;
              if (ov.desc) TYPE_CARD_META[key].desc = ov.desc;
            }
          }
        }
      } catch (e) {
        console.warn('[FrameConfigurator] Failed to parse type card settings:', e);
      }
    }

    // Parse Storefront API config for >250 variant fallback
    var storefrontConfigEl = document.getElementById('frame-storefront-config');
    var storefrontConfig = { token: '', apiVersion: '2024-10' };
    if (storefrontConfigEl) {
      try { storefrontConfig = JSON.parse(storefrontConfigEl.textContent); } catch (e) { /* ignore */ }
    }

    // Parse cross-link config for paper↔canvas product linking
    var crossLinkConfigEl = document.getElementById('frame-cross-link-config');
    var crossLinkConfig = { canvasProductHandle: '', paperProductHandle: '' };
    if (crossLinkConfigEl) {
      try { crossLinkConfig = JSON.parse(crossLinkConfigEl.textContent); } catch (e) { /* ignore */ }
    }

    var variantIndex = buildVariantIndex(productData.variants);

    // Parse product list for product switcher (pre-rendered by Liquid from collection)
    var productsListEl = document.getElementById('frame-products-list');
    var productsList = [];
    if (productsListEl) {
      try {
        productsList = JSON.parse(productsListEl.textContent);
      } catch (e) {
        console.warn('[FrameConfigurator] Failed to parse products list:', e);
      }
    }

    // Build variant indexes for all products in the switcher list
    var allProductVariantIndexes = {};
    for (var pi = 0; pi < productsList.length; pi++) {
      var prod = productsList[pi];
      if (prod.variants && prod.variants.length > 0) {
        allProductVariantIndexes[prod.handle] = buildVariantIndex(prod.variants);
      }
    }

    // --- Truncation detection + lazy variant loading ---
    // Shopify Liquid & REST APIs return max 250 variants. options_with_values always
    // lists ALL types, even when variants are truncated. By comparing defined types
    // vs types present in the variantIndex we detect truncation reliably.
    var _fetchingVariants = {}; // in-flight Storefront API fetches: { handle: Promise }

    /**
     * Check whether a product's variant data is truncated (>250 variants).
     * Compares type values from options_with_values (always complete) against
     * the types actually present in the given variantIndex.
     */
    function isProductTruncated(optionsArray, vIndex) {
      var typeOpt = null;
      if (optionsArray && Array.isArray(optionsArray)) {
        for (var i = 0; i < optionsArray.length; i++) {
          var n = (optionsArray[i].name || '').toLowerCase();
          if (n === 'typ' || n === 'type' || n === 'rahmentyp') {
            typeOpt = optionsArray[i];
            break;
          }
        }
      }
      if (!typeOpt || !typeOpt.values) return false;
      for (var j = 0; j < typeOpt.values.length; j++) {
        if (typeOpt.values[j] !== '_default' && !vIndex[typeOpt.values[j]]) {
          return true; // at least one defined type has no variant data
        }
      }
      return false;
    }

    /**
     * Lazy-load all variants for a product via Storefront API.
     * Uses a per-handle cache and in-flight dedup to avoid duplicate requests.
     * @param {string} handle - Product handle
     * @param {number|string} productId - Shopify product ID
     * @param {Function} callback - Called with the rebuilt variantIndex
     */
    function lazyFetchVariants(handle, productId, callback) {
      // Already fully loaded → use cache
      if (allProductVariantIndexes[handle + '__full']) {
        callback(allProductVariantIndexes[handle]);
        return;
      }
      // Already fetching → piggyback on existing request
      if (_fetchingVariants[handle]) {
        _fetchingVariants[handle].then(function () {
          callback(allProductVariantIndexes[handle]);
        });
        return;
      }
      // Start new fetch
      console.log('[FrameConfigurator] Lazy-loading variants for:', handle);
      _fetchingVariants[handle] = fetchAllVariantsViaStorefrontAPI(productId, storefrontConfig.token, storefrontConfig.apiVersion)
        .then(function (fullVariants) {
          console.log('[FrameConfigurator] Storefront API returned', fullVariants.length, 'variants for', handle);
          allProductVariantIndexes[handle] = buildVariantIndex(fullVariants);
          allProductVariantIndexes[handle + '__full'] = true;
          delete _fetchingVariants[handle];
          callback(allProductVariantIndexes[handle]);
        })
        .catch(function (err) {
          console.error('[FrameConfigurator] Lazy-fetch failed for', handle + ':', err.message);
          delete _fetchingVariants[handle];
        });
    }

    // Determine frame type options from product data
    var frameTypeOption = null;
    var frameTypeValues = [];
    if (productData.options && Array.isArray(productData.options)) {
      for (var oi = 0; oi < productData.options.length; oi++) {
        var optName = (productData.options[oi].name || '').toLowerCase();
        if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
          frameTypeOption = productData.options[oi];
          frameTypeValues = frameTypeOption.values || [];
          break;
        }
      }
    }

    // Detect truncation: types in options_with_values vs types in variantIndex
    var allTypeValues = frameTypeValues.slice();
    var productIsTruncated = isProductTruncated(productData.options, variantIndex);

    if (productIsTruncated && storefrontConfig.token) {
      // Truncated product WITH Storefront API token → show ALL type cards.
      // Missing types will be lazy-loaded via Storefront API on type-card click.
      frameTypeValues = sortTypeValues(allTypeValues);
      console.log('[FrameConfigurator] Truncated product detected. Showing all', frameTypeValues.length,
        'types. Missing types will lazy-load on click.');
    } else {
      // Normal product or no API token → filter to types with actual variant data
      frameTypeValues = sortTypeValues(frameTypeValues.filter(function (tv) {
        return tv === '_default' || variantIndex[tv];
      }));
      var removedTypes = allTypeValues.filter(function (tv) { return frameTypeValues.indexOf(tv) === -1; });
      if (removedTypes.length > 0) {
        console.warn('[FrameConfigurator] Filtered out types with no variants:', removedTypes.join(', '));
        if (!storefrontConfig.token) {
          console.warn('[FrameConfigurator] No Storefront API token configured. Some types may be missing.');
        }
      }
    }

    // For truncated products, pick initial type from types that have loaded variant data
    var initialType = frameTypeValues.length > 0 ? frameTypeValues[0] : '_default';
    if (productIsTruncated) {
      for (var iType = 0; iType < frameTypeValues.length; iType++) {
        if (variantIndex[frameTypeValues[iType]]) {
          initialType = frameTypeValues[iType];
          break;
        }
      }
    }

    // State
    var state = {
      frameType: initialType,
      ppType: 'ohne',
      matWidth: 'standard',
      matColor: 'naturweiss',
      imageWidth: 30,
      imageHeight: 40,
      individualSizes: { top: 5.5, bottom: 6, leftRight: 5.5 },
      suspension: 'zacken',
      currentVariant: null,
      currentPrice: null,
      imageUrl: '',
      imageAspectRatio: null,
      localBlobUrl: null
    };

    // Full-size PP colors (available up to max dimensions)
    var FULL_SIZE_MAT_COLORS = ['naturweiss', 'hellweiss', 'creme', 'schwarz'];

    // Type card display labels (conversion-optimized descriptions)
    var TYPE_CARD_META = {
      'Digitaler Upload': {
        title: 'Papierdruck (Digitaler Upload)',
        desc: 'Wir drucken dein Bild auf Papier und rahmen es.'
      },
      'Digitale Leinwand': {
        title: 'Leinwanddruck (Digitaler Upload)',
        desc: 'Wir drucken dein Bild auf Leinwand und rahmen es'
      },
      'Leinwand aufgespannt': {
        title: 'Aufgespannte Leinwand',
        desc: 'Du sendest uns deine Aufgespannte Leinwand und wir rahmen Sie'
      },
      'Leinwand (aufgespannt)': {
        title: 'Aufgespannte Leinwand',
        desc: 'Du sendest uns deine Aufgespannte Leinwand und wir rahmen Sie'
      },
      'Leinwand nicht aufgespannt': {
        title: 'Leinwand (nicht aufgespannt)',
        desc: 'Du sendest uns deine nicht aufgespannte Leinwand zu und wir rahmen sie'
      },
      'Leinwand (nicht aufgespannt)': {
        title: 'Leinwand (nicht aufgespannt)',
        desc: 'Du sendest uns deine nicht aufgespannte Leinwand zu und wir rahmen sie'
      },
      'Papierarbeit': {
        title: 'Papierarbeit',
        desc: 'Du sendest uns deine Papierarbeit und wir rahmen Sie ein'
      }
    };

    // Suspension descriptions
    var SUSPENSION_INFO = {
      zacken: 'Ein Zacken in der Mitte der oberen Leiste. Nur bis 50cm Breite verf\u00fcgbar.',
      seil: 'Sehr leicht zum Aufh\u00e4ngen und einfach auszurichten. Das Bild kann oben leicht von der Wand abkippen. Erst ab 30cm Breite verf\u00fcgbar.',
      wallbuddies: 'Zwei-Punkt-Aufh\u00e4ngung in den oberen Ecken. Sehr stabil, aber etwas aufw\u00e4ndiger beim Aufh\u00e4ngen. Erst ab 30cm Breite verf\u00fcgbar.'
    };

    // DOM refs
    var typeGroup = document.getElementById('fc-step-type');
    var typeCardsContainer = document.getElementById('fc-type-cards');
    var crossLinkEl = document.getElementById('fc-cross-link');
    var crossLinkTrigger = document.getElementById('fc-cross-link-trigger');
    var crossLinkText = document.getElementById('fc-cross-link-text');
    var crossLinkCards = document.getElementById('fc-cross-link-cards');
    var productSwitcherGroup = document.getElementById('fc-product-switcher-group');
    var productCardsEl = document.getElementById('fc-product-cards');
    var previewContainer = document.getElementById('fc-preview-container');
    var ppTypeOptions = document.getElementById('fc-pp-type-options');
    var ppWidthGroup = document.getElementById('fc-pp-width-group');
    var ppWidthOptions = document.getElementById('fc-pp-width-options');
    var ppWidthHint = document.getElementById('fc-pp-width-hint');
    var ppColorGroup = document.getElementById('fc-pp-color-group');
    var ppColorGrid = document.getElementById('fc-pp-color-grid');
    var ppColorHint = document.getElementById('fc-pp-color-hint');
    var individualInputs = document.getElementById('fc-individual-inputs');
    var widthInput = document.getElementById('fc-width');
    var heightInput = document.getElementById('fc-height');
    var sizeCategoryEl = document.getElementById('fc-size-category');
    var priceEl = document.getElementById('fc-price');
    var overallSizeEl = document.getElementById('fc-overall-size');
    var deliveryEl = document.getElementById('fc-delivery');
    var deliveryHeadlineEl = document.getElementById('fc-delivery-headline');
    var deliverySendinEl = document.getElementById('fc-delivery-sendin');
    var atcButton = document.getElementById('fc-add-to-cart');
    var atcError = document.getElementById('fc-atc-error');
    var variantHintEl = document.getElementById('fc-variant-hint');
    var dimensionsHint = document.getElementById('fc-dimensions-hint');
    var dimensionsError = document.getElementById('fc-dimensions-error');

    // Upload DOM refs
    var uploadInput = document.getElementById('fc-upload-input');
    var uploadDropzone = document.getElementById('fc-upload-dropzone');
    var uploadPrompt = document.getElementById('fc-upload-prompt');
    var uploadProgress = document.getElementById('fc-upload-progress');
    var uploadProgressBar = document.getElementById('fc-upload-progress-bar');
    var uploadProgressText = document.getElementById('fc-upload-progress-text');
    var uploadThumbWrap = document.getElementById('fc-upload-thumb-wrap');
    var uploadThumb = document.getElementById('fc-upload-thumb');
    var uploadChangeBtn = document.getElementById('fc-upload-change');
    var uploadRotateBtn = document.getElementById('fc-upload-rotate');
    var uploadCropBtn = document.getElementById('fc-upload-crop');
    var uploadRemoveBtn = document.getElementById('fc-upload-remove');
    var uploadBtn = document.getElementById('fc-upload-btn');
    var suspensionOptions = document.getElementById('fc-suspension-options');
    var suspensionHint = document.getElementById('fc-suspension-hint');
    var viewToggle = document.getElementById('fc-product-view-toggle');

    /* --- MOBILE SPLIT-SCREEN ELEMENTS --- */
    var mobilePreview = document.getElementById('fc-mobile-preview');
    var mobilePreviewImage = document.getElementById('fc-mobile-preview-image');
    var mobilePreviewSlider = document.getElementById('fc-mobile-preview-slider');
    var mobilePreviewDots = document.getElementById('fc-mobile-preview-dots');
    var mobileInfoTitle = document.getElementById('fc-mobile-info-title');
    var mobileInfoPrice = document.getElementById('fc-mobile-info-price');
    var isMobileQuery = window.matchMedia('(max-width: 749px)');

    /* --- ACCORDION LOGIC --- */
    var openStepId = 'size';
    var visitedSteps = {};

    function toggleStep(stepId) {
      // Mark previously open step as visited
      if (openStepId && openStepId !== stepId) {
        visitedSteps[openStepId] = true;
      }
      openStepId = (openStepId === stepId) ? null : stepId;
      var steps = document.querySelectorAll('.fc-step[data-step-id]');
      for (var si = 0; si < steps.length; si++) {
        var step = steps[si];
        var id = step.dataset.stepId;
        var isOpen = id === openStepId;
        step.classList.toggle('fc-step--open', isOpen);
        step.classList.toggle('fc-step--current', isOpen);
        step.classList.toggle('fc-step--visited', !isOpen && visitedSteps[id]);
        var header = step.querySelector('.fc-step__header');
        if (header) header.setAttribute('aria-expanded', String(isOpen));
        var content = step.querySelector('.fc-step__content');
        if (content) {
          if (isOpen) {
            // Start with scrollHeight for animation, then switch to none so content can grow
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.opacity = '1';
            // IIFE to capture correct content reference (var has function scope)
            (function (el) {
              setTimeout(function () { el.style.maxHeight = 'none'; }, 350);
            })(content);
          } else {
            // Snap from 'none' to scrollHeight so browser can transition to 0
            content.style.maxHeight = content.scrollHeight + 'px';
            content.offsetHeight; // Force reflow
            content.style.maxHeight = '0';
            content.style.opacity = '0';
          }
        }
      }
      // Update scroll arrows when frame step opens (after animation and after maxHeight: none)
      if (stepId === 'frame') {
        setTimeout(updateScrollArrows, 100);
        setTimeout(updateScrollArrows, 400);
      }
      // Update mobile step indicator
      updateStepSubtitles();
    }

    function updateStepSubtitles() {
      // Size subtitle
      var sizeSubEl = document.getElementById('fc-step-size-subtitle');
      if (sizeSubEl) sizeSubEl.textContent = state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm';

      // Frame subtitle
      var frameSubEl = document.getElementById('fc-step-frame-subtitle');
      if (frameSubEl) frameSubEl.textContent = productData.title || '';

      // PP subtitle
      var ppSubEl = document.getElementById('fc-step-pp-subtitle');
      if (ppSubEl) {
        var ppLabel = state.ppType === 'ohne' ? 'Ohne' : (state.ppType === 'einfach' ? 'Einfach' : 'Innenligend');
        ppSubEl.textContent = ppLabel + (state.ppType !== 'ohne' ? ' / ' + state.matColor : '');
      }

      // Suspension subtitle
      var susSubEl = document.getElementById('fc-step-suspension-subtitle');
      if (susSubEl) {
        var susLabel = state.suspension === 'wallbuddies' ? 'Wall Buddies' : (state.suspension.charAt(0).toUpperCase() + state.suspension.slice(1));
        susSubEl.textContent = susLabel;
      }

    }

    // Initialize accordion - step headers get click handlers here.
    // The actual open step is set later in initialization (after URL params + renderTypeCards).
    (function initAccordion() {
      toggleStep('size');
      // Bind click handlers on step headers
      var headers = document.querySelectorAll('.fc-step__header');
      for (var hi = 0; hi < headers.length; hi++) {
        headers[hi].addEventListener('click', function () {
          var step = this.closest('.fc-step[data-step-id]');
          if (step) toggleStep(step.dataset.stepId);
        });
      }
    })();
    var uploadError = document.getElementById('fc-upload-error');
    var uploadGroup = document.getElementById('fc-upload-group');
    var uploadGroupLabel = uploadGroup ? uploadGroup.querySelector('.fc-group__label') : null;

    // Helper: Check if current frame type requires image upload
    function isUploadRequired() {
      var ft = (state.frameType || '').toLowerCase();
      return ft === 'digitaler upload' || ft === 'digitale leinwand';
    }

    // Helper: Check if current frame type supports auto aspect-ratio
    function isAutoAspectType() {
      var ft = (state.frameType || '').toLowerCase();
      return ft === 'digitaler upload' || ft === 'digitale leinwand';
    }

    /**
     * Reorder images for upload context: move first image to last.
     * When customer has uploaded an image, the 2nd product image is most relevant
     * (typically a detail/profile shot), so it should appear first.
     */
    function reorderImagesForUpload(images) {
      if (!images || images.length < 2 || !state.imageUrl) return images;
      return images.slice(1).concat([images[0]]);
    }

    /**
     * After reordering gallery slides, re-init dots + reset slider pages so navigation works.
     * Optionally scrolls to SVG preview if scrollToPreview is true.
     */
    function refreshGalleryAfterReorder(scrollToPreview) {
      setTimeout(function () {
        initGalleryDots();
        reBindGalleryThumbnails();
        var mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery && mediaGallery.elements && mediaGallery.elements.viewer) {
          var viewer = mediaGallery.elements.viewer;
          if (typeof viewer.resetPages === 'function') {
            try { viewer.resetPages(); } catch (e) { /* ignore */ }
          }
        }
        if (scrollToPreview) {
          _userClickedThumbnail = false;
          scrollGalleryToPreview();
        }
      }, 100);
    }

    /**
     * Reorder existing desktop gallery slides:
     * When user has configured (size/PP/upload): move SVG preview to front, first product image to last.
     * When restoring: move SVG back to end, restore first product image to front.
     */
    function reorderDesktopGallerySlides() {
      var slides = document.querySelectorAll('.fc-page-product-image');
      if (slides.length < 2) return;
      var parent = slides[0].parentElement;
      if (!parent) return;

      // Also reorder thumbnails
      var thumbs = document.querySelectorAll('.fc-page-product-thumb');

      // Find SVG preview slide and thumbnail
      var svgSlide = parent.querySelector('[data-media-id$="-fc-preview"]');
      var thumbParent = thumbs.length > 0 ? thumbs[0].parentElement : null;
      var svgThumb = thumbParent ? thumbParent.querySelector('[data-target$="-fc-preview"]') : null;

      if (_userHasConfigured) {
        // Move SVG preview to front
        if (svgSlide) parent.insertBefore(svgSlide, parent.firstElementChild);
        if (svgThumb && thumbParent) thumbParent.insertBefore(svgThumb, thumbParent.firstElementChild);
        // Move first product image to end
        parent.appendChild(slides[0]);
        if (thumbs.length > 1 && thumbParent) {
          thumbParent.appendChild(thumbs[0]);
        }
      } else {
        // Restore: move SVG back to end
        if (svgSlide) parent.appendChild(svgSlide);
        if (svgThumb && thumbParent) thumbParent.appendChild(svgThumb);
        // Move last product slide (originally first) back to front
        if (slides.length > 1) {
          parent.insertBefore(slides[slides.length - 1], parent.firstElementChild);
          if (thumbs.length > 1 && thumbParent) {
            thumbParent.insertBefore(thumbs[thumbs.length - 1], thumbParent.firstElementChild);
          }
        }
      }
    }

    /**
     * Reorder existing mobile gallery slides: move SVG to front + first product image to last
     * (or restore). Called after config change or upload/removal.
     */
    function reorderMobileGallerySlides() {
      if (!mobilePreviewSlider) return;
      var imgSlides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide--image');
      if (imgSlides.length < 2) return;

      var svgSlide = mobilePreviewSlider.querySelector('.fc-mobile-preview__slide--svg');

      if (_userHasConfigured) {
        // Move SVG to front, first product image to end
        if (svgSlide) mobilePreviewSlider.insertBefore(svgSlide, mobilePreviewSlider.firstElementChild);
        mobilePreviewSlider.appendChild(imgSlides[0]);
      } else {
        // Restore: SVG to end, original first image to front
        if (svgSlide) mobilePreviewSlider.appendChild(svgSlide);
        if (imgSlides.length > 1) {
          mobilePreviewSlider.insertBefore(imgSlides[imgSlides.length - 1], mobilePreviewSlider.firstElementChild);
        }
      }
      updateMobilePreviewDots();
    }

    // IndexedDB helpers — persist image blob + Firebase URL for reload
    function saveImageToIDB(blob, firebaseUrl) {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onupgradeneeded = function (e) { e.target.result.createObjectStore('blobs'); };
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readwrite');
          var store = tx.objectStore('blobs');
          if (blob) store.put(blob, 'uploadedImage');
          if (firebaseUrl) store.put(firebaseUrl, 'firebaseUrl');
        };
      } catch (e) { /* IndexedDB not available */ }
    }
    function loadImageFromIDB(callback) {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onupgradeneeded = function (e) { e.target.result.createObjectStore('blobs'); };
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readonly');
          var store = tx.objectStore('blobs');
          var getBlob = store.get('uploadedImage');
          var getUrl = store.get('firebaseUrl');
          var result = { blob: null, firebaseUrl: null };
          getBlob.onsuccess = function () { result.blob = getBlob.result || null; };
          getUrl.onsuccess = function () { result.firebaseUrl = getUrl.result || null; };
          tx.oncomplete = function () { callback(result); };
          tx.onerror = function () { callback(result); };
        };
        req.onerror = function () { callback({ blob: null, firebaseUrl: null }); };
      } catch (e) { callback({ blob: null, firebaseUrl: null }); }
    }
    function clearImageFromIDB() {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readwrite');
          var store = tx.objectStore('blobs');
          store.delete('uploadedImage');
          store.delete('firebaseUrl');
        };
      } catch (e) { /* ignore */ }
    }

    // Upload state (Firebase Client SDK — direct browser-to-Firebase, no server/proxy needed)

    // Verify critical DOM elements
    if (!ppTypeOptions || !ppWidthOptions || !ppColorGrid || !previewContainer) {
      console.error('[FrameConfigurator] Missing critical DOM elements:', {
        ppTypeOptions: !!ppTypeOptions,
        ppWidthOptions: !!ppWidthOptions,
        ppColorGrid: !!ppColorGrid,
        previewContainer: !!previewContainer
      });
      return;
    }

    /* --- UI HELPERS (defined before use) --- */

    function setActiveButton(container, activeBtn) {
      container.querySelectorAll('.fc-option-btn').forEach(function (b) { b.classList.remove('fc-option-btn--active'); });
      activeBtn.classList.add('fc-option-btn--active');
    }

    function setActiveSwatch(container, swatch) {
      container.querySelectorAll('.fc-swatch').forEach(function (s) { s.classList.remove('fc-swatch--active'); });
      swatch.classList.add('fc-swatch--active');
    }

    function togglePPOptions() {
      var show = state.ppType !== 'ohne';
      ppWidthGroup.classList.toggle('fc-group--hidden', !show);
      ppColorGroup.classList.toggle('fc-group--hidden', !show);
      // After showing/hiding PP sub-groups, update the step content maxHeight
      // so the accordion can grow/shrink to fit the new content.
      var ppContent = document.querySelector('#fc-step-pp .fc-step__content');
      if (ppContent && document.querySelector('#fc-step-pp').classList.contains('fc-step--open')) {
        ppContent.style.maxHeight = 'none';
      }
    }

    /**
     * Check if a frameType has any PP variants (einfach/freigestellt) in the variant index.
     * Returns false for frame types that only have 'ohne' PP (e.g. Leinwand).
     */
    function frameTypeHasPP(frameType) {
      var typeMap = variantIndex[frameType];
      if (!typeMap) return false;
      var sizeKeys = Object.keys(typeMap);
      for (var i = 0; i < sizeKeys.length; i++) {
        var sizeMap = typeMap[sizeKeys[i]];
        var ppKeys = Object.keys(sizeMap);
        for (var j = 0; j < ppKeys.length; j++) {
          if (ppKeys[j] !== 'ohne') return true;
        }
      }
      return false;
    }

    /**
     * Hide the entire PP step when the current frameType has no PP variants
     * (e.g. Leinwand). Also updates step numbering (Aufhängung becomes 3 instead of 4).
     */
    function updatePPStepVisibility() {
      var ppStep = document.getElementById('fc-step-pp');
      var suspensionStep = document.getElementById('fc-step-suspension');
      if (!ppStep || !suspensionStep) return;

      var hasPP = frameTypeHasPP(state.frameType);

      // Show/hide PP step
      ppStep.style.display = hasPP ? '' : 'none';

      // Update Aufhängung step number: 4 when PP hidden, 5 when PP visible
      var susNumber = suspensionStep.querySelector('.fc-step__number');
      if (susNumber) susNumber.textContent = hasPP ? '5' : '4';

      // Force ppType to 'ohne' when PP not available
      if (!hasPP && state.ppType !== 'ohne') {
        state.ppType = 'ohne';
        syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
        togglePPOptions();
      }
    }

    function toggleIndividualInputs() {
      individualInputs.classList.toggle('fc-group--hidden', state.matWidth !== 'individual');
      // Update PP step maxHeight after content change
      var ppContent = document.querySelector('#fc-step-pp .fc-step__content');
      if (ppContent && document.querySelector('#fc-step-pp').classList.contains('fc-step--open')) {
        ppContent.style.maxHeight = 'none';
      }
    }

    function syncButtonState(container, attrName, value) {
      container.querySelectorAll('.fc-option-btn').forEach(function (btn) {
        btn.classList.toggle('fc-option-btn--active', btn.getAttribute(attrName) === value);
      });
    }

    /* --- MAT COLOR SWATCHES --- */

    function renderMatColorSwatches() {
      var html = '';
      SHARED_MAT_COLOR_OPTIONS.forEach(function (opt) {
        var active = opt.color === state.matColor ? ' fc-swatch--active' : '';
        html += '<button type="button" class="fc-swatch' + active + '"' +
          ' data-mat-color="' + opt.color + '"' +
          ' data-mat-display-name="' + opt.displayName + '"' +
          ' title="' + opt.displayName + '"' +
          ' aria-label="Passepartout-Farbe: ' + opt.displayName + '">' +
          (opt.imageUrl
            ? '<img src="' + opt.imageUrl + '" alt="' + opt.displayName + '" loading="lazy" width="36" height="36">'
            : '<span class="fc-swatch__fallback"></span>') +
          '</button>';
      });
      ppColorGrid.innerHTML = html;
    }

    /* --- PRODUCT SWITCHER --- */

    /**
     * Return only products that have a variant matching the current
     * size category + PP type combination.
     */
    /**
     * Get all products that have at least one variant of the current frameType.
     * Each product gets a .available flag indicating whether a variant exists
     * for the current size + PP combination.
     */
    function getFilteredProducts() {
      var sizeCategory = getSizeCategory(
        state.imageWidth, state.imageHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );
      var sizeKey = normalizeSizeKey(sizeCategory);
      var ppKey = normalizePPType(state.ppType);

      var filtered = [];
      for (var i = 0; i < productsList.length; i++) {
        var p = productsList[i];
        var idx = allProductVariantIndexes[p.handle];
        if (!idx) continue;

        // Check if product has the current frameType — either in variant index
        // or in options metadata (variants may not be loaded due to Shopify 250-variant limit)
        var hasFrameTypeInIndex = Boolean(idx[state.frameType]);
        var hasFrameTypeInOptions = false;
        if (!hasFrameTypeInIndex && p.options && Array.isArray(p.options)) {
          for (var oi = 0; oi < p.options.length; oi++) {
            var optName = (p.options[oi].name || '').toLowerCase();
            if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
              var vals = p.options[oi].values || [];
              hasFrameTypeInOptions = vals.indexOf(state.frameType) !== -1;
              break;
            }
          }
        }
        if (!hasFrameTypeInIndex && !hasFrameTypeInOptions) continue;

        // Check if product has a matching variant for current size + PP
        var typeMap = hasFrameTypeInIndex ? idx[state.frameType] : null;
        var sizeMap = typeMap ? typeMap[sizeKey] : null;
        var hasVariant = Boolean(sizeMap && (sizeMap[ppKey] || sizeMap['ohne']));

        // If frame type exists in options but variants aren't loaded yet,
        // show as available (optimistic) — lazy loading will fetch on click
        if (!hasFrameTypeInIndex && hasFrameTypeInOptions) {
          hasVariant = true;
        }

        var entry = {};
        for (var key in p) { if (p.hasOwnProperty(key)) entry[key] = p[key]; }
        entry._available = hasVariant;
        filtered.push(entry);
      }
      return filtered;
    }

    /** Extract unique color categories from product tags (format: "Farbe: Schwarz") */
    function extractColorCategories(products) {
      var colorSet = {};
      for (var i = 0; i < products.length; i++) {
        var tags = products[i].tags || [];
        for (var j = 0; j < tags.length; j++) {
          var tag = tags[j];
          if (tag.indexOf('Farbe:') === 0 || tag.indexOf('farbe:') === 0) {
            var color = tag.split(':')[1].trim();
            if (color) colorSet[color] = true;
          }
        }
      }
      return Object.keys(colorSet).sort();
    }

    /** Get color tags for a single product */
    function getProductColors(product) {
      var colors = [];
      var tags = product.tags || [];
      for (var j = 0; j < tags.length; j++) {
        var tag = tags[j];
        if (tag.indexOf('Farbe:') === 0 || tag.indexOf('farbe:') === 0) {
          var color = tag.split(':')[1].trim();
          if (color) colors.push(color);
        }
      }
      return colors;
    }

    /** Update the info box to show a specific product's details */
    function updateFrameInfoBox(product) {
      var infoBox = document.getElementById('fc-frame-info');
      if (!infoBox) return;
      var hoeheEl = infoBox.querySelector('.fc-frame-info__hoehe');
      var breiteEl = infoBox.querySelector('.fc-frame-info__breite');
      if (hoeheEl) hoeheEl.textContent = (product.frameHoeheMM || 15) + ' mm';
      if (breiteEl) breiteEl.textContent = (product.frameBreiteMM || 24) + ' mm';
    }

    /** Get a short one-line description from the product (first sentence or first 80 chars) */
    function getShortDescription(product) {
      var raw = product.description || '';
      // Strip HTML tags
      var text = raw.replace(/<[^>]*>/g, '').trim();
      if (!text) return '';
      // First sentence or up to 80 chars
      var dot = text.indexOf('.');
      if (dot > 0 && dot < 80) return text.substring(0, dot + 1);
      if (text.length > 80) return text.substring(0, 77) + '\u2026';
      return text;
    }

    /** Scroll active swatch into view within the horizontal scroll container */
    function scrollActiveSwatchIntoView() {
      var container = document.getElementById('fc-frame-swatches');
      if (!container) return;
      var active = container.querySelector('.fc-frame-swatch--active');
      if (!active) return;
      var containerRect = container.getBoundingClientRect();
      var swatchRect = active.getBoundingClientRect();
      // If swatch is outside visible area, scroll it into center
      if (swatchRect.left < containerRect.left || swatchRect.right > containerRect.right) {
        var scrollTarget = active.offsetLeft - container.offsetWidth / 2 + active.offsetWidth / 2;
        container.scrollTo({ left: scrollTarget, behavior: 'instant' });
      }
    }

    var _activeFilterTab = 'Alle';

    function renderProductSwitcher() {
      if (!productSwitcherGroup || !productCardsEl) {
        if (productSwitcherGroup) productSwitcherGroup.style.display = 'none';
        return;
      }

      var filtered = getFilteredProducts();

      if (filtered.length < 2) {
        productSwitcherGroup.style.display = 'none';
        return;
      }

      productSwitcherGroup.style.display = '';

      // Pre-compute short descriptions
      for (var i = 0; i < filtered.length; i++) {
        if (typeof filtered[i]._shortDesc === 'undefined') {
          filtered[i]._shortDesc = getShortDescription(filtered[i]);
        }
      }

      // Find active product for info box
      var activeProduct = null;
      for (var i = 0; i < filtered.length; i++) {
        if (filtered[i].handle === productData.handle) { activeProduct = filtered[i]; break; }
      }
      if (!activeProduct) activeProduct = filtered[0];

      // 1. Filter tabs (from tags "Farbe: ...")
      var html = '';
      var categories = extractColorCategories(filtered);
      if (categories.length > 1) {
        html += '<div class="fc-frame-tabs" id="fc-frame-tabs">';
        html += '<button type="button" class="fc-frame-tab' + (_activeFilterTab === 'Alle' ? ' fc-frame-tab--active' : '') + '" data-filter="Alle">Alle</button>';
        for (var c = 0; c < categories.length; c++) {
          html += '<button type="button" class="fc-frame-tab' + (_activeFilterTab === categories[c] ? ' fc-frame-tab--active' : '') + '" data-filter="' + categories[c] + '">' + categories[c] + '</button>';
        }
        html += '</div>';
      }

      // 3. Swatch row with scroll fade
      html += '<div class="fc-frame-swatches-wrap">';
      html += '<div class="fc-frame-swatches" id="fc-frame-swatches">';
      for (var i = 0; i < filtered.length; i++) {
        var p = filtered[i];
        var isActive = p.handle === productData.handle;
        var isAvailable = p._available !== false;
        var imgSrc = p.frameImageLR || p.featuredImage || '';
        var productColors = getProductColors(p);
        var colorDataAttr = productColors.length ? productColors.join(',') : '';
        var shortDesc = p._shortDesc || '';

        var classes = 'fc-frame-swatch';
        if (isActive) classes += ' fc-frame-swatch--active';
        if (!isAvailable && !isActive) classes += ' fc-frame-swatch--disabled';
        // Apply filter visibility
        if (_activeFilterTab !== 'Alle' && productColors.indexOf(_activeFilterTab) === -1) {
          classes += ' fc-frame-swatch--hidden';
        }

        var breiteMM = p.frameBreiteMM || 24;
        var hoeheMM = p.frameHoeheMM || 15;

        html += '<button type="button" class="' + classes + '"'
          + ' data-handle="' + p.handle + '"'
          + ' data-title="' + (p.title || '').replace(/"/g, '&quot;') + '"'
          + ' data-breite="' + breiteMM + '"'
          + ' data-hoehe="' + hoeheMM + '"'
          + ' data-desc="' + shortDesc.replace(/"/g, '&quot;') + '"'
          + ' data-colors="' + colorDataAttr + '"'
          + ' title="' + (p.title || '') + '"'
          + (!isAvailable && !isActive ? ' disabled' : '')
          + '>'
          + '<div class="fc-frame-swatch__img-wrap">'
          + (imgSrc ? '<img src="' + imgSrc + '" alt="' + (p.title || '') + '" loading="lazy">' : '')
          + '</div>'
          + '</button>';
      }
      html += '</div>';
      html += '</div>'; // .fc-frame-swatches-wrap

      productCardsEl.innerHTML = html;

      // Update frame info box with active product's dimensions
      updateFrameInfoBox(activeProduct || productData);

      // Scroll active swatch into view after render
      requestAnimationFrame(scrollActiveSwatchIntoView);

      // Update scroll fade indicators
      var swatchContainer = document.getElementById('fc-frame-swatches');
      if (swatchContainer) {
        var updateFade = function () {
          var wrap = swatchContainer.parentElement;
          if (!wrap) return;
          var atStart = swatchContainer.scrollLeft <= 2;
          var atEnd = swatchContainer.scrollLeft >= swatchContainer.scrollWidth - swatchContainer.clientWidth - 2;
          wrap.classList.toggle('fc-frame-swatches-wrap--fade-left', !atStart);
          wrap.classList.toggle('fc-frame-swatches-wrap--fade-right', !atEnd);
        };
        swatchContainer.addEventListener('scroll', debounce(updateFade, 50));
        requestAnimationFrame(updateFade);

        // Desktop: convert vertical mouse wheel to horizontal scroll
        swatchContainer.addEventListener('wheel', function (e) {
          // Only intercept if container actually overflows horizontally
          if (swatchContainer.scrollWidth <= swatchContainer.clientWidth) return;
          // Only convert vertical scroll (deltaY) — don't interfere with horizontal trackpad
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && e.deltaY !== 0) {
            e.preventDefault();
            swatchContainer.scrollLeft += e.deltaY;
          }
        }, { passive: false });

        // Desktop: drag-to-scroll (mouse only, not touch)
        var _dragState = { active: false, startX: 0, scrollLeft: 0 };
        swatchContainer.addEventListener('mousedown', function (e) {
          // Only left button, skip if clicking a swatch button
          if (e.button !== 0) return;
          if (swatchContainer.scrollWidth <= swatchContainer.clientWidth) return;
          _dragState.active = true;
          _dragState.startX = e.pageX;
          _dragState.scrollLeft = swatchContainer.scrollLeft;
          swatchContainer.classList.add('fc-frame-swatches--grabbing');
          e.preventDefault();
        });
        document.addEventListener('mousemove', function (e) {
          if (!_dragState.active) return;
          var dx = e.pageX - _dragState.startX;
          swatchContainer.scrollLeft = _dragState.scrollLeft - dx;
        });
        document.addEventListener('mouseup', function () {
          if (!_dragState.active) return;
          _dragState.active = false;
          swatchContainer.classList.remove('fc-frame-swatches--grabbing');
        });
      }
    }

    /* --- TYPE DROPDOWN --- */

    function hasCrossLink() {
      var cat = classifyProductTypes(frameTypeValues);
      if (cat === 'paper-only' && crossLinkConfig.canvasProductHandle) return true;
      if (cat === 'canvas-only' && crossLinkConfig.paperProductHandle) return true;
      return false;
    }

    function renderTypeCards() {
      if (!typeCardsContainer || (frameTypeValues.length < 2 && !hasCrossLink())) {
        // Hide accordion if only 1 or 0 types and no cross-link
        if (typeGroup) typeGroup.style.display = 'none';
        return;
      }
      typeGroup.style.display = '';
      var html = '';
      for (var i = 0; i < frameTypeValues.length; i++) {
        var val = frameTypeValues[i];
        var meta = TYPE_CARD_META[val] || { title: val, desc: '' };
        var isSelected = val === state.frameType;
        html += '<div class="fc-type-card' + (isSelected ? ' fc-type-card--selected' : '') + '"'
          + ' role="radio"'
          + ' aria-checked="' + (isSelected ? 'true' : 'false') + '"'
          + ' tabindex="' + (isSelected ? '0' : '-1') + '"'
          + ' data-type-value="' + val + '">'
          + '<div class="fc-type-card__radio"></div>'
          + '<div class="fc-type-card__text">'
          + '<span class="fc-type-card__title">' + meta.title + '</span>'
          + (meta.desc ? '<span class="fc-type-card__desc">' + meta.desc + '</span>' : '')
          + '</div>'
          + '</div>';
      }
      typeCardsContainer.innerHTML = html;

      // Update accordion subtitle with current selection
      var typeSubtitle = document.getElementById('fc-step-type-subtitle');
      if (typeSubtitle) {
        var currentMeta = TYPE_CARD_META[state.frameType] || { title: state.frameType };
        typeSubtitle.textContent = currentMeta.title;
      }

      renderCrossLink();
    }

    function renderCrossLink() {
      if (!crossLinkEl) return;
      var productCategory = classifyProductTypes(frameTypeValues);

      if (productCategory === 'full' || productCategory === 'unknown') {
        crossLinkEl.style.display = 'none';
        return;
      }

      var targetHandle, promptText, altTypes;
      if (productCategory === 'paper-only') {
        targetHandle = crossLinkConfig.canvasProductHandle || '';
        promptText = 'M\u00F6chtest du eine Leinwand rahmen lassen?';
        altTypes = ['Digitale Leinwand', 'Leinwand nicht aufgespannt', 'Leinwand aufgespannt'];
      } else if (productCategory === 'canvas-only') {
        targetHandle = crossLinkConfig.paperProductHandle || '';
        promptText = 'M\u00F6chtest du ein Papier einrahmen?';
        altTypes = ['Digitaler Upload', 'Papierarbeit'];
      } else {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Auto-detect target from productsList if no section setting configured
      if (!targetHandle) {
        var neededCategory = (productCategory === 'paper-only') ? 'canvas' : 'paper';
        var neededKeys = (neededCategory === 'canvas') ? CANVAS_TYPE_KEYS : PAPER_TYPE_KEYS;
        for (var p = 0; p < productsList.length; p++) {
          var pl = productsList[p];
          if (pl.handle === productData.handle) continue;
          var plOpts = pl.options || [];
          for (var oi = 0; oi < plOpts.length; oi++) {
            var oName = (plOpts[oi].name || '').toLowerCase();
            if (oName === 'typ' || oName === 'type' || oName === 'rahmentyp') {
              var plVals = plOpts[oi].values || [];
              for (var vi = 0; vi < plVals.length; vi++) {
                if (neededKeys.indexOf(normalizeTypeKey(plVals[vi])) !== -1) {
                  targetHandle = pl.handle;
                  break;
                }
              }
              break;
            }
          }
          if (targetHandle) break;
        }
      }

      if (!targetHandle) {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Verify target exists in productsList
      var targetExists = false;
      for (var p2 = 0; p2 < productsList.length; p2++) {
        if (productsList[p2].handle === targetHandle) { targetExists = true; break; }
      }
      if (!targetExists) {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Filter altTypes to only those available on target product
      var targetProduct = null;
      for (var tp = 0; tp < productsList.length; tp++) {
        if (productsList[tp].handle === targetHandle) { targetProduct = productsList[tp]; break; }
      }
      if (targetProduct) {
        var targetTypeValues = [];
        var tpOpts = targetProduct.options || [];
        for (var toi = 0; toi < tpOpts.length; toi++) {
          var toName = (tpOpts[toi].name || '').toLowerCase();
          if (toName === 'typ' || toName === 'type' || toName === 'rahmentyp') {
            targetTypeValues = tpOpts[toi].values || [];
            break;
          }
        }
        var targetNormalized = targetTypeValues.map(function (v) { return normalizeTypeKey(v); });
        altTypes = altTypes.filter(function (at) {
          return targetNormalized.indexOf(normalizeTypeKey(at)) !== -1;
        });
      }
      if (altTypes.length === 0) {
        crossLinkEl.style.display = 'none';
        return;
      }

      crossLinkEl.style.display = '';
      crossLinkText.textContent = promptText;

      // Render alternative type cards
      var html = '';
      for (var j = 0; j < altTypes.length; j++) {
        var val = altTypes[j];
        var meta = TYPE_CARD_META[val] || { title: val, desc: '' };
        html += '<div class="fc-type-card fc-type-card--cross"'
          + ' role="radio" aria-checked="false" tabindex="-1"'
          + ' data-cross-type="' + val + '"'
          + ' data-cross-handle="' + targetHandle + '">'
          + '<div class="fc-type-card__radio"></div>'
          + '<div class="fc-type-card__text">'
          + '<span class="fc-type-card__title">' + meta.title + '</span>'
          + (meta.desc ? '<span class="fc-type-card__desc">' + meta.desc + '</span>' : '')
          + '</div>'
          + '</div>';
      }
      crossLinkCards.innerHTML = html;
      // Reset expanded state
      crossLinkCards.style.display = 'none';
      if (crossLinkTrigger) crossLinkTrigger.classList.remove('fc-cross-link__trigger--open');
    }

    /* --- SVG PREVIEW --- */

    function renderPreview() {
      if (typeof window.generateFramePreviewSvg !== 'function') {
        console.log('[FrameConfigurator] Waiting for generateFramePreviewSvg...');
        setTimeout(renderPreview, 150);
        return;
      }

      try {
        var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

        var matType = 'none';
        if (state.ppType === 'einfach') matType = 'standard';
        if (state.ppType === 'freigestellt') matType = 'inner';

        var individualSizesForPreview = null;
        if (state.matWidth === 'individual') {
          individualSizesForPreview = {
            top: state.individualSizes.top,
            bottom: state.individualSizes.bottom,
            left: state.individualSizes.leftRight,
            right: state.individualSizes.leftRight
          };
        }

        var frameSpec = {
          imageUrl: state.imageUrl || '',
          frameConfig: {
            productId: productData.productId,
            frameImageLR: productData.frameImageLR || '',
            frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
            frameWidth: productData.frameBreiteMM || 24
          },
          matConfig: {
            type: matType,
            width: state.matWidth,
            color: state.matColor,
            colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
            individualSizes: individualSizesForPreview
          },
          dimensions: { width: state.imageWidth, height: state.imageHeight },
          rotation: 0
        };

        var svgMarkup = window.generateFramePreviewSvg(frameSpec);
        previewContainer.innerHTML = svgMarkup;

        var svgEl = previewContainer.querySelector('svg');
        if (svgEl) {
          svgEl.removeAttribute('width');
          svgEl.removeAttribute('height');
          svgEl.style.maxWidth = '92%';
          svgEl.style.maxHeight = '92%';
          svgEl.style.width = 'auto';
          svgEl.style.height = 'auto';
        }

        updateThumbnailPreview();
        updateMobilePreview();
      } catch (err) {
        console.warn('[FrameConfigurator] renderPreview error:', err);
      }
    }

    /* --- THUMBNAIL SYNC --- */

    function updateThumbnailPreview() {
      var thumbnailContainer = document.getElementById('fc-thumbnail-preview');
      if (!thumbnailContainer || !previewContainer) return;

      var mainSvg = previewContainer.querySelector('svg');
      if (!mainSvg) return;

      var clone = mainSvg.cloneNode(true);
      clone.style.width = '100%';
      clone.style.height = '100%';
      thumbnailContainer.innerHTML = '';
      thumbnailContainer.appendChild(clone);
    }

    /**
     * Sync the mobile split-screen preview with the current SVG.
     * WhiteWall-style: large canvas at top, SVG scales responsively.
     */
    function updateMobilePreview() {
      if (!mobilePreviewImage || !isMobileQuery.matches) return;

      var mainSvg = previewContainer.querySelector('svg');
      if (mainSvg) {
        var clone = mainSvg.cloneNode(true);
        // Remove explicit width/height attrs so viewBox controls aspect ratio.
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.style.width = '';
        clone.style.height = '';
        clone.style.maxWidth = '100%';
        clone.style.maxHeight = '100%';

        // Deduplicate pattern/clipPath IDs to avoid conflicts with main SVG.
        // Duplicate IDs cause fill="url(#...)" to reference the wrong (hidden) element.
        var suffix = '-mob';
        var idEls = clone.querySelectorAll('[id]');
        for (var i = 0; i < idEls.length; i++) {
          var oldId = idEls[i].id;
          idEls[i].id = oldId + suffix;
        }
        // Update all url(#...) references in fill, stroke, clip-path, mask attrs
        var refAttrs = ['fill', 'stroke', 'clip-path', 'mask'];
        var allEls = clone.querySelectorAll('*');
        for (var j = 0; j < allEls.length; j++) {
          for (var k = 0; k < refAttrs.length; k++) {
            var val = allEls[j].getAttribute(refAttrs[k]);
            if (val && val.indexOf('url(#') !== -1) {
              allEls[j].setAttribute(refAttrs[k], val.replace(/url\(#([^)]+)\)/g, 'url(#$1' + suffix + ')'));
            }
          }
        }

        mobilePreviewImage.innerHTML = '';
        mobilePreviewImage.appendChild(clone);
      }
    }

    /* --- MOBILE PREVIEW GALLERY (swipeable carousel: SVG + product images) --- */

    /**
     * Populate the mobile preview carousel with product images.
     * Slide 0 (SVG) is always present in the HTML.
     * Slides 1+ are product images, dynamically created here.
     */
    function populateMobileGallery(images) {
      if (!mobilePreviewSlider) return;

      // Remove existing product image slides (keep SVG slide)
      var oldSlides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide--image');
      for (var i = 0; i < oldSlides.length; i++) oldSlides[i].remove();

      var svgSlide = mobilePreviewSlider.querySelector('.fc-mobile-preview__slide--svg');
      var orderedImages = reorderImagesForUpload(images);
      if (orderedImages && orderedImages.length > 0) {
        for (var j = 0; j < orderedImages.length; j++) {
          var slide = document.createElement('div');
          slide.className = 'fc-mobile-preview__slide fc-mobile-preview__slide--image';
          var img = document.createElement('img');
          img.src = orderedImages[j].url;
          img.alt = orderedImages[j].alt || '';
          img.loading = 'lazy';
          slide.appendChild(img);
          if (_userHasConfigured) {
            // SVG first, product images after
            mobilePreviewSlider.appendChild(slide);
          } else {
            // Product images first, SVG last
            mobilePreviewSlider.insertBefore(slide, svgSlide);
          }
        }
      }

      updateMobilePreviewDots();
    }

    /**
     * Rebuild the dot indicators for the mobile preview carousel.
     */
    function updateMobilePreviewDots() {
      if (!mobilePreviewDots || !mobilePreviewSlider) return;
      var slides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide');
      mobilePreviewDots.innerHTML = '';
      if (slides.length < 2) return;

      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fc-mobile-preview__dot' + (i === 0 ? ' fc-mobile-preview__dot--active' : '');
        dot.setAttribute('aria-label', 'Bild ' + (i + 1));
        dot.dataset.index = String(i);
        mobilePreviewDots.appendChild(dot);
      }
    }

    // Scroll handler — update active dot on swipe
    if (mobilePreviewSlider) {
      mobilePreviewSlider.addEventListener('scroll', debounce(function () {
        if (!mobilePreviewDots) return;
        var scrollLeft = mobilePreviewSlider.scrollLeft;
        var slideWidth = mobilePreviewSlider.offsetWidth;
        if (slideWidth === 0) return;
        var activeIndex = Math.round(scrollLeft / slideWidth);
        var dots = mobilePreviewDots.querySelectorAll('.fc-mobile-preview__dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('fc-mobile-preview__dot--active', i === activeIndex);
        }
      }, 50));
    }

    // Dot click handler — scroll to corresponding slide
    if (mobilePreviewDots) {
      mobilePreviewDots.addEventListener('click', function (e) {
        var dot = e.target.closest('.fc-mobile-preview__dot');
        if (!dot || !mobilePreviewSlider) return;
        var idx = parseInt(dot.dataset.index, 10);
        var slides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide');
        if (slides[idx]) {
          mobilePreviewSlider.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
        }
      });
    }

    /* --- GALLERY NAVIGATION --- */

    var _sectionId = '';
    (function findSectionId() {
      // Try product-info element first (standard product page)
      var sectionEl = document.querySelector('product-info[data-section]');
      if (sectionEl) { _sectionId = sectionEl.dataset.section; return; }
      // Fallback: extract section ID from media-gallery element (configurator page)
      var galleryEl = document.querySelector('media-gallery[id^="MediaGallery-"]');
      if (galleryEl) { _sectionId = galleryEl.id.replace('MediaGallery-', ''); return; }
      // Fallback: extract from configurator container data attribute
      var fcContainer = document.getElementById('frame-configurator');
      if (fcContainer && fcContainer.dataset.sectionId) { _sectionId = fcContainer.dataset.sectionId; }
    })();

    // Flag: true when user manually clicked a gallery thumbnail
    // Prevents auto-scroll to SVG preview from overriding user choice
    var _userClickedThumbnail = false;
    // Flag: false during init, true after first update — prevents auto-scroll on page load
    var _initialized = false;
    // Flag: true after user changes size, PP, or uploads an image — triggers SVG-first gallery
    var _userHasConfigured = false;

    function scrollGalleryToPreview() {
      if (!_sectionId) return;
      if (_userClickedThumbnail) return; // User clicked a thumbnail — don't override

      var mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery || typeof mediaGallery.setActiveMedia !== 'function') return;

      var previewMediaId = _sectionId + '-fc-preview';
      var activeSlides = mediaGallery.querySelectorAll('.product__media-item.is-active');

      // Skip only if the preview is the sole active slide
      if (activeSlides.length === 1 && activeSlides[0].dataset.mediaId === previewMediaId) return;

      mediaGallery.setActiveMedia(previewMediaId, false, false);
    }

    /**
     * Re-bind click handlers for gallery thumbnails (after dynamic DOM updates).
     * Also resets slider pages so new slides are recognized.
     * Sets _userClickedThumbnail = true on click so auto-scroll is suppressed.
     */
    function reBindGalleryThumbnails() {
      var mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery || !mediaGallery.elements || !mediaGallery.elements.thumbnails) return;

      mediaGallery.elements.thumbnails.querySelectorAll('[data-target]').forEach(function (mediaToSwitch) {
        var btn = mediaToSwitch.querySelector('button');
        if (!btn || btn._fcBound) return; // Skip if already bound
        btn._fcBound = true;
        btn.addEventListener('click', function () {
          _userClickedThumbnail = true;
          mediaGallery.setActiveMedia(mediaToSwitch.dataset.target, false, true);
        });
      });

      // Tell both sliders to re-discover their slide items
      // Wrapped in try-catch because Dawn's resetPages() may access
      // elements that aren't fully initialized yet (null .style access)
      try {
        var viewer = mediaGallery.elements.viewer;
        if (viewer && typeof viewer.resetPages === 'function') {
          viewer.resetPages();
        }
        var thumbSlider = mediaGallery.elements.thumbnails;
        if (thumbSlider && typeof thumbSlider.resetPages === 'function') {
          thumbSlider.resetPages();
        }
      } catch (e) {
        // Dawn slider not fully initialized — safe to ignore
      }
    }

    /* --- GALLERY DOTS --- */

    var _galleryDotsScrollHandler = null;

    function initGalleryDots() {
      var slider = document.querySelector('.product__media-list');
      if (!slider) return;
      var slides = slider.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;

      // Remove existing dots (idempotent)
      var existingDots = document.querySelector('.fc-gallery-dots');
      if (existingDots) existingDots.remove();

      // Remove previous scroll handler
      if (_galleryDotsScrollHandler) {
        slider.removeEventListener('scroll', _galleryDotsScrollHandler);
      }

      // Create dots container
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'fc-gallery-dots';
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'fc-gallery-dot' + (i === 0 ? ' fc-gallery-dot--active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Bild ' + (i + 1));
        dot.dataset.index = i;
        dotsWrap.appendChild(dot);
      }

      // Insert dots after the slider (before thumbnail-slider)
      var mediaWrapper = slider.closest('.product__media-gallery');
      if (mediaWrapper) {
        var thumbSlider = mediaWrapper.querySelector('.thumbnail-slider');
        if (thumbSlider) {
          mediaWrapper.insertBefore(dotsWrap, thumbSlider);
        } else {
          mediaWrapper.appendChild(dotsWrap);
        }
      }

      // Move arrows below dots (desktop: Image → Dots → Arrows)
      var sliderButtons = document.querySelector('.product__media-wrapper .slider-buttons');
      if (sliderButtons && dotsWrap && dotsWrap.parentNode) {
        dotsWrap.parentNode.insertBefore(sliderButtons, dotsWrap.nextSibling);
      }

      // Click handler for dots — query slides fresh to avoid stale references after reorder
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.fc-gallery-dot');
        if (!dot) return;
        var idx = parseInt(dot.dataset.index, 10);
        var currentSlides = slider.querySelectorAll('.product__media-item');
        var targetSlide = currentSlides[idx];
        if (targetSlide) {
          slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
      });

      // Scroll handler — update active dot
      _galleryDotsScrollHandler = debounce(function () {
        var scrollLeft = slider.scrollLeft;
        var slideWidth = slider.offsetWidth;
        var activeIndex = Math.round(scrollLeft / slideWidth);
        var dots = dotsWrap.querySelectorAll('.fc-gallery-dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('fc-gallery-dot--active', i === activeIndex);
        }
      }, 50);
      slider.addEventListener('scroll', _galleryDotsScrollHandler);
    }

    /* --- PRODUCT SWITCHING --- */

    /**
     * Detect if we are on the standalone configurator page.
     * If so, we can switch products entirely client-side (instant).
     * If not (normal product page), navigate to the configurator page.
     */
    var fcModeEl = document.getElementById('frame-configurator');
    var fcMode = (fcModeEl && fcModeEl.dataset.fcMode) || 'configurator';
    var isConfiguratorPage = (fcMode === 'configurator');
    var isProductPage = (fcMode === 'product');

    /**
     * Build URL params string from current configurator state.
     */
    function buildStateParams(targetHandle, targetVariantId) {
      var params = new URLSearchParams();
      params.set('product', targetHandle);
      if (state.frameType && state.frameType !== '_default') params.set('frameType', state.frameType);
      params.set('ppType', state.ppType);
      params.set('matWidth', state.matWidth);
      params.set('matColor', state.matColor);
      params.set('width', state.imageWidth);
      params.set('height', state.imageHeight);
      if (state.matWidth === 'individual') {
        params.set('matTop', state.individualSizes.top);
        params.set('matBottom', state.individualSizes.bottom);
        params.set('matSides', state.individualSizes.leftRight);
      }
      if (targetVariantId) params.set('variant', targetVariantId);
      return params;
    }

    /**
     * Update page-level DOM elements (title, vendor, description, images)
     * when switching products on the configurator page.
     */
    function updatePageInfo(target) {
      // Title
      var titleEl = document.getElementById('fc-page-title');
      if (titleEl) titleEl.textContent = target.title;
      // Mobile info bar title
      if (mobileInfoTitle) mobileInfoTitle.textContent = target.title;

      // Breadcrumb product name
      var breadcrumbEl = document.getElementById('fc-page-breadcrumb-product');
      if (breadcrumbEl) breadcrumbEl.textContent = target.title;

      // Vendor
      var vendorEl = document.getElementById('fc-page-vendor');
      if (vendorEl && target.vendor) {
        vendorEl.innerHTML = '<a href="/collections/vendors?q=' + encodeURIComponent(target.vendor) + '" class="link">' + target.vendor + '</a>';
      }

      // Description
      var descEl = document.getElementById('fc-page-description');
      if (descEl && target.description !== undefined) {
        descEl.innerHTML = target.description;
      }

      // Price — handled by update() which sets the correct config price on #fc-page-price

      // Page title
      document.title = target.title + ' – ' + (window.Shopify && window.Shopify.shop ? window.Shopify.shop.replace('.myshopify.com', '') : 'Shop');

      // Product images in gallery — remove old ones and insert new
      var oldImages = document.querySelectorAll('.fc-page-product-image');
      var oldThumbs = document.querySelectorAll('.fc-page-product-thumb');

      if (target.images && target.images.length > 0) {
        // Find the gallery <ul> and thumbnail <ul> from the first old element or by ID pattern
        var galleryUl = oldImages.length > 0
          ? oldImages[0].parentElement
          : document.querySelector('[id^="Slider-Gallery-"]');
        var thumbUl = oldThumbs.length > 0
          ? oldThumbs[0].parentElement
          : document.querySelector('[id^="Slider-Thumbnails-"]');

        // Determine section ID from gallery
        var sectionId = galleryUl ? (galleryUl.id || '').replace('Slider-Gallery-', '') : '';

        // Remove old product image slides
        for (var ri = 0; ri < oldImages.length; ri++) oldImages[ri].remove();
        for (var rt = 0; rt < oldThumbs.length; rt++) oldThumbs[rt].remove();

        // Insert new product image slides (reorder if image uploaded)
        var orderedImgs = reorderImagesForUpload(target.images);
        for (var i = 0; i < orderedImgs.length; i++) {
          var img = orderedImgs[i];
          var pos = i + 1;
          var ratio = img.height && img.width ? (img.height / img.width * 100) : 133;

          // Main gallery slide
          var li = document.createElement('li');
          li.id = 'Slide-' + sectionId + '-img-' + pos;
          li.className = 'product__media-item grid__item slider__slide fc-page-product-image';
          li.setAttribute('data-media-id', sectionId + '-img-' + pos);
          li.setAttribute('data-media-position', String(pos));
          li.innerHTML = '<div class="media media--adapt" style="padding-bottom:' + ratio + '%;">'
            + '<img src="' + img.url + '" alt="' + (img.alt || target.title) + '" loading="lazy" width="' + (img.width || '') + '" height="' + (img.height || '') + '">'
            + '</div>';
          if (galleryUl) galleryUl.appendChild(li);

          // Thumbnail slide
          var thumbLi = document.createElement('li');
          thumbLi.id = 'Slide-Thumbnails-' + sectionId + '-' + pos;
          thumbLi.className = 'thumbnail-list__item slider__slide media-wrapper media-wrapper--small fc-page-product-thumb';
          thumbLi.setAttribute('data-target', sectionId + '-img-' + pos);
          thumbLi.setAttribute('data-media-position', String(pos));
          thumbLi.innerHTML = '<button class="thumbnail media media--square" aria-controls="GalleryViewer-' + sectionId + '">'
            + '<img src="' + img.url + '" alt="' + (img.alt || target.title) + '" loading="lazy">'
            + '</button>';
          if (thumbUl) thumbUl.appendChild(thumbLi);
        }

        // Update slide counter
        if (galleryUl) {
          var counterWrap = galleryUl.closest('.slider-mobile-gutter');
          if (counterWrap) {
            var totalEl = counterWrap.querySelector('.slider-counter--total');
            if (totalEl) totalEl.textContent = String(target.images.length + 1);
          }
        }
      }

      // Re-bind gallery thumbnail click handlers for newly created elements
      reBindGalleryThumbnails();
    }

    /**
     * Switch to a different frame product.
     * On configurator page: instant client-side swap.
     * On product page: navigate to configurator page with state params.
     */
    function switchProduct(handle) {
      if (handle === productData.handle) return;

      // 1. Find target product in the pre-rendered list
      var targetProduct = null;
      for (var i = 0; i < productsList.length; i++) {
        if (productsList[i].handle === handle) {
          targetProduct = productsList[i];
          break;
        }
      }
      if (!targetProduct) {
        console.error('[FrameConfigurator] Product not found in list:', handle);
        return;
      }

      // 2. Look up the matching variant on the target product
      var targetIdx = allProductVariantIndexes[handle];
      var targetVariantId = null;
      if (targetIdx) {
        var sizeCategory = getSizeCategory(
          state.imageWidth, state.imageHeight,
          state.ppType === 'ohne' ? 'ohne' : state.matWidth,
          productData.frameBreiteMM, state.ppType, state.individualSizes
        );
        var variant = lookupVariant(targetIdx, state.frameType, sizeCategory, state.ppType);
        if (!variant) {
          var typeKeys = Object.keys(targetIdx);
          for (var t = 0; t < typeKeys.length; t++) {
            variant = lookupVariant(targetIdx, typeKeys[t], sizeCategory, state.ppType);
            if (variant) break;
          }
        }
        if (variant) targetVariantId = variant.id;
      }

      // 3. Save uploaded image URL to sessionStorage
      if (state.imageUrl && !state.imageUrl.startsWith('blob:')) {
        try { sessionStorage.setItem('fc-transfer-imageUrl', state.imageUrl); } catch (e) { /* ignore */ }
      }

      // --- CLIENT-SIDE SWITCH (shared by configurator page AND product page) ---
      if (isConfiguratorPage || isProductPage) {
        console.log('[FrameConfigurator] Client-side switch to:', handle, '(mode:', fcMode, ')');

        // Update productData with new product's data
        productData.frameImageLR = targetProduct.frameImageLR;
        productData.frameImageTB = targetProduct.frameImageTB || targetProduct.frameImageLR;
        productData.frameBreiteMM = targetProduct.frameBreiteMM;
        productData.frameHoeheMM = targetProduct.frameHoeheMM;
        productData.title = targetProduct.title;
        productData.handle = handle;
        productData.productId = targetProduct.productId;
        productData.url = targetProduct.url;
        productData.priceMin = targetProduct.priceMin;
        productData.options = targetProduct.options;

        // Rebuild variant index for the new product
        variantIndex = allProductVariantIndexes[handle] || variantIndex;

        // Update frame type options from product options metadata
        var newTypeKeys = [];
        if (targetProduct.options && Array.isArray(targetProduct.options)) {
          for (var oi = 0; oi < targetProduct.options.length; oi++) {
            var optName = (targetProduct.options[oi].name || '').toLowerCase();
            if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
              newTypeKeys = targetProduct.options[oi].values || [];
              break;
            }
          }
        }
        // Fallback to variant index keys if no options metadata
        if (newTypeKeys.length === 0) {
          newTypeKeys = Object.keys(variantIndex);
        }
        // Detect truncation for switched product (lazy loading approach)
        var switchTruncated = isProductTruncated(targetProduct.options, variantIndex);
        productIsTruncated = switchTruncated;

        if (switchTruncated && storefrontConfig.token) {
          // Truncated: show ALL type cards, lazy-load missing types on click
          newTypeKeys = sortTypeValues(newTypeKeys);
          console.log('[FrameConfigurator] Switched to truncated product:', handle,
            '- showing all', newTypeKeys.length, 'types (lazy-load on click)');
        } else {
          // Normal: filter to types with actual variant data
          newTypeKeys = sortTypeValues(newTypeKeys.filter(function (tv) {
            return tv === '_default' || variantIndex[tv];
          }));
        }

        if (newTypeKeys.length > 0 && newTypeKeys[0] !== '_default') {
          frameTypeValues = newTypeKeys;
          allTypeValues = newTypeKeys.slice();
          // Check URL params for a requested frameType (may not have matched the
          // initial product but could be valid for this switched product)
          var urlParams = new URLSearchParams(window.location.search);
          var urlFrameType = urlParams.get('frameType');
          if (urlFrameType && frameTypeValues.indexOf(urlFrameType) !== -1) {
            state.frameType = urlFrameType;
          } else if (switchTruncated && frameTypeValues.indexOf(state.frameType) === -1) {
            // For truncated products, prefer a type that has loaded variant data
            var foundLoaded = false;
            for (var ltk = 0; ltk < frameTypeValues.length; ltk++) {
              if (variantIndex[frameTypeValues[ltk]]) {
                state.frameType = frameTypeValues[ltk];
                foundLoaded = true;
                break;
              }
            }
            if (!foundLoaded) state.frameType = frameTypeValues[0];
          } else if (frameTypeValues.indexOf(state.frameType) === -1) {
            state.frameType = frameTypeValues[0];
          }
          renderTypeCards();
        }

        // Re-render SVG preview + price immediately
        update();

        // Proactive variant loading: if product is truncated, immediately fetch ALL
        // variants via Storefront API so every clickable option has data ready.
        if (switchTruncated && storefrontConfig.token && !allProductVariantIndexes[handle + '__full']) {
          var fetchHandle = handle;
          priceEl.textContent = 'Lade Preise\u2026';
          if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
          atcButton.disabled = true;
          lazyFetchVariants(fetchHandle, targetProduct.productId, function (newIndex) {
            if (productData.handle !== fetchHandle) return;
            variantIndex = newIndex;
            productIsTruncated = false;
            update();
          });
        }

        // Update frame info box with new product's dimensions
        updateFrameInfoBox(targetProduct);

        // Update page-level info (title, images, description, etc.)
        updatePageInfo(targetProduct);

        // Update mobile preview gallery with new product images
        populateMobileGallery(targetProduct.images);
        if (mobilePreviewSlider) {
          mobilePreviewSlider.scrollTo({ left: 0, behavior: 'instant' });
        }

        // After product switch: if customer uploaded an image, stay on SVG preview;
        // otherwise scroll to first product image.
        _userClickedThumbnail = false;
        if (!state.imageUrl) {
          var firstImgSlide = document.querySelector('.fc-page-product-image');
          if (firstImgSlide) {
            var mediaGallery = document.querySelector('media-gallery');
            if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
              mediaGallery.setActiveMedia(firstImgSlide.dataset.mediaId, false, false);
            }
          }
        } else {
          scrollGalleryToPreview();
        }

        // Rebuild gallery dots (slide count may have changed)
        refreshGalleryAfterReorder();

        // Re-render product switcher to update active swatch
        renderProductSwitcher();

        // Update URL without reload (build params AFTER frameType is set correctly)
        var stateParams = buildStateParams(handle, targetVariantId);
        if (isProductPage) {
          // Product page: URL is /products/<handle>?params
          stateParams.delete('product');
          var newUrl = '/products/' + handle + '?' + stateParams.toString();
          window.history.pushState({ fcHandle: handle }, '', newUrl);
        } else {
          // Configurator page: URL stays on same path with ?product=handle
          var newUrl = window.location.pathname + '?' + stateParams.toString();
          window.history.pushState({ fcHandle: handle }, '', newUrl);
        }

        return;
      }

      // --- FALLBACK: navigate to configurator page ---
      var stateParams = buildStateParams(handle, targetVariantId);
      var configuratorUrl = '/pages/konfigurator?' + stateParams.toString();
      console.log('[FrameConfigurator] Navigating to configurator page:', configuratorUrl);
      window.location.href = configuratorUrl;
    }

    /* --- AVAILABILITY CHECKING --- */

    /**
     * Update availability indicators on PP type buttons, PP color swatches,
     * and suspension options. Called at the end of update().
     */
    function updateAvailability() {
      // Get current size category for availability check
      var sizeCategory = getSizeCategory(
        state.imageWidth, state.imageHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );
      var sizeKey = normalizeSizeKey(sizeCategory);
      var typeMap = variantIndex[state.frameType] || {};
      var sizeMap = typeMap[sizeKey] || {};

      // PP type buttons: mark unavailable only if no variant exists for that PP type
      // Must compute size category PER PP type, since PP changes the perimeter
      if (ppTypeOptions) {
        ppTypeOptions.querySelectorAll('[data-pp-type]').forEach(function (btn) {
          var ppKey = normalizePPType(btn.dataset.ppType);
          var matWidthForCheck = ppKey === 'ohne' ? 'ohne' : state.matWidth;
          var sizeCatForPP = getSizeCategory(
            state.imageWidth, state.imageHeight,
            matWidthForCheck,
            productData.frameBreiteMM, ppKey, state.individualSizes
          );
          var sizeKeyForPP = normalizeSizeKey(sizeCatForPP);
          var sizeMapForPP = typeMap[sizeKeyForPP] || {};
          var isAvailable = Boolean(sizeMapForPP[ppKey]);
          // Fallback: if 'ohne' exists at this size, variant lookup will find it
          if (!isAvailable && ppKey !== 'ohne') {
            isAvailable = Boolean(sizeMapForPP['ohne']);
          }
          btn.classList.toggle('fc-option-btn--unavailable', !isAvailable);
        });
      }

      // PP color restriction by outer dimensions
      // Only Naturweiß, Hellweiß, Creme, Schwarz available up to max size (110×90)
      // All others only up to Außenmaß 100×80 / 80×100
      if (ppColorGrid && state.ppType !== 'ohne') {
        var isNoPP = state.ppType === 'ohne';
        var matTopCM = 0, matBottomCM = 0, matLeftRightCM = 0;
        if (!isNoPP) {
          if (state.matWidth === 'individual' && state.individualSizes) {
            matTopCM = state.individualSizes.top || 0;
            matBottomCM = state.individualSizes.bottom || 0;
            matLeftRightCM = state.individualSizes.leftRight || 0;
          } else {
            var preset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
            matTopCM = preset.top;
            matBottomCM = preset.bottom;
            matLeftRightCM = preset.leftRight;
          }
        }
        var outerWidth = state.imageWidth + 2 * matLeftRightCM + 2 * (productData.frameBreiteMM / 10);
        var outerHeight = state.imageHeight + matTopCM + matBottomCM + 2 * (productData.frameHoeheMM / 10);
        // Over limit: outer dimensions exceed 100×80 or 80×100
        var isOverColorLimit = (outerWidth > 100 && outerHeight > 80) || (outerHeight > 100 && outerWidth > 80);

        var needsColorSwitch = false;
        ppColorGrid.querySelectorAll('[data-mat-color]').forEach(function (swatch) {
          var color = swatch.dataset.matColor;
          var isFullSize = FULL_SIZE_MAT_COLORS.indexOf(color) !== -1;
          var isDisabled = !isFullSize && isOverColorLimit;
          swatch.classList.toggle('fc-swatch--disabled', isDisabled);
          swatch.disabled = isDisabled;
          if (isDisabled && color === state.matColor) needsColorSwitch = true;
        });

        // Auto-switch to allowed color if current is disabled
        if (needsColorSwitch) {
          state.matColor = 'naturweiss';
          var fallback = ppColorGrid.querySelector('[data-mat-color="naturweiss"]');
          if (fallback) {
            setActiveSwatch(ppColorGrid, fallback);
            ppColorHint.textContent = fallback.dataset.matDisplayName || '';
          }
        }
      }

      // PP width preset availability: disable presets that would exceed outer limit
      // OR have no matching variant in the index for the resulting size category
      if (ppWidthOptions && state.ppType !== 'ohne') {
        var needsWidthSwitch = false;
        ppWidthOptions.querySelectorAll('[data-pp-width]').forEach(function (btn) {
          var widthKey = btn.dataset.ppWidth;
          if (widthKey === 'individual') {
            // Individual is always shown; constrained via dynamic input max
            btn.classList.remove('fc-option-btn--disabled');
            btn.disabled = false;
            return;
          }
          var wPreset = PRESET_PASSPARTOUT_DIMENSIONS[widthKey];
          if (!wPreset) return;

          // Check 1: outer dimensions fit within 110×90
          var wOuter = calculateOuterDimensions(
            state.imageWidth, state.imageHeight,
            wPreset.top, wPreset.bottom, wPreset.leftRight
          );
          var wFits = fitsOuterLimit(wOuter.width, wOuter.height);

          // Check 2: a variant exists for this width's size category + current PP type
          var hasVariant = false;
          if (wFits) {
            var wSizeCat = getSizeCategory(
              state.imageWidth, state.imageHeight,
              widthKey,
              productData.frameBreiteMM, state.ppType, null
            );
            var wSizeKey = normalizeSizeKey(wSizeCat);
            var wSizeMap = typeMap[wSizeKey] || {};
            var wPPKey = normalizePPType(state.ppType);
            hasVariant = Boolean(wSizeMap[wPPKey]) || Boolean(wSizeMap['ohne']);
          }

          var isAvailable = wFits && hasVariant;
          btn.classList.toggle('fc-option-btn--disabled', !isAvailable);
          btn.disabled = !isAvailable;
          if (!isAvailable && widthKey === state.matWidth) needsWidthSwitch = true;
        });

        // Auto-fallback to smaller PP width if current is disabled
        if (needsWidthSwitch) {
          var fallbackWidths = ['standard', 'thin'];
          var foundFallback = false;
          for (var fw = 0; fw < fallbackWidths.length; fw++) {
            var fbPreset = PRESET_PASSPARTOUT_DIMENSIONS[fallbackWidths[fw]];
            var fbOuter = calculateOuterDimensions(
              state.imageWidth, state.imageHeight,
              fbPreset.top, fbPreset.bottom, fbPreset.leftRight
            );
            if (!fitsOuterLimit(fbOuter.width, fbOuter.height)) continue;
            // Also check variant exists for this fallback width
            var fbSizeCat = getSizeCategory(
              state.imageWidth, state.imageHeight,
              fallbackWidths[fw],
              productData.frameBreiteMM, state.ppType, null
            );
            var fbSizeKey = normalizeSizeKey(fbSizeCat);
            var fbSizeMap = typeMap[fbSizeKey] || {};
            var fbPPKey = normalizePPType(state.ppType);
            if (Boolean(fbSizeMap[fbPPKey]) || Boolean(fbSizeMap['ohne'])) {
              state.matWidth = fallbackWidths[fw];
              syncButtonState(ppWidthOptions, 'data-pp-width', state.matWidth);
              toggleIndividualInputs();
              foundFallback = true;
              break;
            }
          }
          // If no preset fits, switch to ohne
          if (!foundFallback) {
            state.ppType = 'ohne';
            syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
            togglePPOptions();
          }
        }
      }

      // Clamp individual PP sizes based on available space
      if (state.ppType !== 'ohne' && state.matWidth === 'individual') {
        clampIndividualSizes();
      }

      // Suspension availability
      updateSuspensionAvailability();
    }

    /**
     * Clamp individual PP size inputs to ensure outer dimensions stay within 110×90 limit.
     */
    function clampIndividualSizes() {
      var frameWidthCM = productData.frameBreiteMM / 10;
      var frameHeightCM = (productData.frameHoeheMM || productData.frameBreiteMM) / 10;

      // Max left/right so outerWidth <= 110
      var maxLR = Math.floor(((110 - state.imageWidth - 2 * frameWidthCM) / 2) * 10) / 10;
      maxLR = Math.min(25, Math.max(2, maxLR));

      // Max vertical total so outerHeight <= 110
      var maxVerticalTotal = 110 - state.imageHeight - 2 * frameHeightCM;
      var maxTop = Math.min(25, Math.max(2, Math.floor((maxVerticalTotal - 2) * 10) / 10));
      var maxBottom = Math.min(25, Math.max(2, Math.floor((maxVerticalTotal - 2) * 10) / 10));

      // Update input max attributes
      var matTopInput = document.getElementById('fc-mat-top');
      var matBottomInput = document.getElementById('fc-mat-bottom');
      var matSidesInput = document.getElementById('fc-mat-sides');
      if (matSidesInput) matSidesInput.max = maxLR;
      if (matTopInput) matTopInput.max = maxTop;
      if (matBottomInput) matBottomInput.max = maxBottom;

      // Clamp current values if they exceed new max
      if (state.individualSizes.leftRight > maxLR) {
        state.individualSizes.leftRight = maxLR;
        if (matSidesInput) matSidesInput.value = maxLR;
      }
      if (state.individualSizes.top > maxTop) {
        state.individualSizes.top = maxTop;
        if (matTopInput) matTopInput.value = maxTop;
      }
      if (state.individualSizes.bottom > maxBottom) {
        state.individualSizes.bottom = maxBottom;
        if (matBottomInput) matBottomInput.value = maxBottom;
      }
    }

    /**
     * Update suspension option availability based on total frame width.
     * Zacken: only up to 50cm total width.
     * Seil / Wall Buddies: only from 30cm total width.
     * Auto-switch: Zacken → Seil when >50cm.
     */
    function updateSuspensionAvailability() {
      if (!suspensionOptions) return;

      // Calculate total width: imageWidth + 2× frame width + 2× PP side width
      var isNoPP = state.ppType === 'ohne';
      var matSideCM = 0;
      if (!isNoPP) {
        if (state.matWidth === 'individual' && state.individualSizes) {
          matSideCM = state.individualSizes.leftRight || 0;
        } else {
          var preset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
          matSideCM = preset.leftRight;
        }
      }
      var totalWidth = state.imageWidth + 2 * matSideCM + 2 * (productData.frameBreiteMM / 10);

      var zackenOk = totalWidth <= 50;
      var seilOk = totalWidth >= 30;
      var wallbuddiesOk = totalWidth >= 30;

      suspensionOptions.querySelectorAll('[data-suspension]').forEach(function (btn) {
        var type = btn.dataset.suspension;
        var ok = type === 'zacken' ? zackenOk : (type === 'seil' ? seilOk : wallbuddiesOk);
        btn.classList.toggle('fc-option-btn--disabled', !ok);
        btn.disabled = !ok;
      });

      // Auto-switch: if current is Zacken and width >50cm → switch to Seil
      if (state.suspension === 'zacken' && !zackenOk) {
        state.suspension = seilOk ? 'seil' : 'wallbuddies';
        syncButtonState(suspensionOptions, 'data-suspension', state.suspension);
      }
      // If current is Seil or WallBuddies and width <30cm → switch to Zacken
      if ((state.suspension === 'seil' || state.suspension === 'wallbuddies') && !seilOk) {
        state.suspension = 'zacken';
        syncButtonState(suspensionOptions, 'data-suspension', state.suspension);
      }

      // Update hint text
      if (suspensionHint) {
        suspensionHint.textContent = SUSPENSION_INFO[state.suspension] || '';
      }
    }

    /* --- IMAGE UPLOAD (via App Proxy) --- */

    /**
     * Upload UI helpers
     */
    function showUploadProgress(pct) {
      if (!uploadProgress) return;
      uploadPrompt.style.display = 'none';
      uploadThumbWrap.style.display = 'none';
      uploadProgress.style.display = '';
      uploadProgressBar.style.width = Math.round(pct) + '%';
      uploadProgressText.textContent = Math.round(pct) + '%';
    }

    function showUploadPreview(url) {
      if (!uploadThumbWrap) return;
      uploadPrompt.style.display = 'none';
      uploadProgress.style.display = 'none';
      uploadThumbWrap.style.display = '';
      uploadThumb.src = url;
    }

    function showUploadError(msg) {
      if (!uploadError) return;
      uploadError.textContent = msg;
      uploadError.style.display = '';
      setTimeout(function () { uploadError.style.display = 'none'; }, 6000);
    }

    function resetUploadUI() {
      if (!uploadPrompt) return;
      uploadPrompt.style.display = '';
      uploadProgress.style.display = 'none';
      uploadThumbWrap.style.display = 'none';
      uploadThumb.src = '';
      uploadProgressBar.style.width = '0%';
      uploadProgressText.textContent = '0%';
      uploadError.style.display = 'none';
      if (uploadInput) uploadInput.value = '';
      // Reset aspect ratio lock
      state.imageAspectRatio = null;
      clearImageFromIDB();
      // Clean up blob URL
      if (state.localBlobUrl) {
        URL.revokeObjectURL(state.localBlobUrl);
        state.localBlobUrl = null;
      }
    }

    /**
     * Crop overlay — simple drag-to-select crop tool
     */
    function openCropOverlay(imageSrc) {
      var overlay = document.getElementById('fc-crop-overlay');
      var cropImg = document.getElementById('fc-crop-image');
      var selection = document.getElementById('fc-crop-selection');
      var cancelBtn = document.getElementById('fc-crop-cancel');
      var confirmBtn = document.getElementById('fc-crop-confirm');
      var imageWrap = document.getElementById('fc-crop-image-wrap');
      if (!overlay || !cropImg || !selection || !cancelBtn || !confirmBtn || !imageWrap) return;

      // Set crossOrigin only for HTTP URLs, not blobs
      if (imageSrc && imageSrc.indexOf('blob:') !== 0) {
        cropImg.crossOrigin = 'anonymous';
      } else {
        cropImg.removeAttribute('crossOrigin');
      }

      overlay.style.display = '';

      var cropState = { sx: 0, sy: 0, sw: 0, sh: 0, dragging: false, resizing: false, startX: 0, startY: 0 };

      function cleanup() {
        overlay.style.display = 'none';
        imageWrap.removeEventListener('mousedown', onStart);
        imageWrap.removeEventListener('touchstart', onStart);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchend', onEnd);
        cancelBtn.onclick = null;
        confirmBtn.onclick = null;
      }

      cropImg.onerror = function () {
        showUploadError('Bild konnte nicht geladen werden.');
        cleanup();
      };

      cropImg.onload = function () {
        var imgRect = cropImg.getBoundingClientRect();
        var iw = imgRect.width;
        var ih = imgRect.height;
        cropState.sx = Math.round(iw * 0.1);
        cropState.sy = Math.round(ih * 0.1);
        cropState.sw = Math.round(iw * 0.8);
        cropState.sh = Math.round(ih * 0.8);
        updateSelection();
      };

      cropImg.src = imageSrc;

      // Calculate image offset within the flex container (image may not fill entire wrap)
      function getImageOffset() {
        var imgRect = cropImg.getBoundingClientRect();
        var wrapRect = imageWrap.getBoundingClientRect();
        return { x: imgRect.left - wrapRect.left, y: imgRect.top - wrapRect.top };
      }

      function updateSelection() {
        var offset = getImageOffset();
        selection.style.left = (cropState.sx + offset.x) + 'px';
        selection.style.top = (cropState.sy + offset.y) + 'px';
        selection.style.width = cropState.sw + 'px';
        selection.style.height = cropState.sh + 'px';
      }

      function getRelativePos(e) {
        var r = cropImg.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var clientY = e.touches ? e.touches[0].clientY : e.clientY;
        return { x: clientX - r.left, y: clientY - r.top };
      }

      function onStart(e) {
        e.preventDefault();
        var pos = getRelativePos(e);
        var edgeThreshold = 18;
        var nearRight = Math.abs(pos.x - (cropState.sx + cropState.sw)) < edgeThreshold;
        var nearBottom = Math.abs(pos.y - (cropState.sy + cropState.sh)) < edgeThreshold;
        var nearLeft = Math.abs(pos.x - cropState.sx) < edgeThreshold;
        var nearTop = Math.abs(pos.y - cropState.sy) < edgeThreshold;

        if ((nearRight || nearLeft) && (nearTop || nearBottom)) {
          cropState.resizing = true;
          cropState.resizeCorner = (nearTop ? 't' : 'b') + (nearLeft ? 'l' : 'r');
        } else if (pos.x >= cropState.sx && pos.x <= cropState.sx + cropState.sw &&
                   pos.y >= cropState.sy && pos.y <= cropState.sy + cropState.sh) {
          cropState.dragging = true;
        }
        cropState.startX = pos.x;
        cropState.startY = pos.y;
        cropState.origSx = cropState.sx;
        cropState.origSy = cropState.sy;
        cropState.origSw = cropState.sw;
        cropState.origSh = cropState.sh;
      }

      function onMove(e) {
        if (!cropState.dragging && !cropState.resizing) return;
        e.preventDefault();
        var pos = getRelativePos(e);
        var dx = pos.x - cropState.startX;
        var dy = pos.y - cropState.startY;
        var imgRect = cropImg.getBoundingClientRect();
        var maxW = imgRect.width;
        var maxH = imgRect.height;

        if (cropState.dragging) {
          cropState.sx = Math.max(0, Math.min(maxW - cropState.sw, cropState.origSx + dx));
          cropState.sy = Math.max(0, Math.min(maxH - cropState.sh, cropState.origSy + dy));
        } else if (cropState.resizing) {
          var corner = cropState.resizeCorner;
          if (corner.indexOf('r') !== -1) {
            cropState.sw = Math.max(40, Math.min(maxW - cropState.sx, cropState.origSw + dx));
          }
          if (corner.indexOf('l') !== -1) {
            var newSx = Math.max(0, cropState.origSx + dx);
            cropState.sw = cropState.origSw + (cropState.origSx - newSx);
            if (cropState.sw >= 40) cropState.sx = newSx;
          }
          if (corner.indexOf('b') !== -1) {
            cropState.sh = Math.max(40, Math.min(maxH - cropState.sy, cropState.origSh + dy));
          }
          if (corner.indexOf('t') !== -1) {
            var newSy = Math.max(0, cropState.origSy + dy);
            cropState.sh = cropState.origSh + (cropState.origSy - newSy);
            if (cropState.sh >= 40) cropState.sy = newSy;
          }
        }
        updateSelection();
      }

      function onEnd() {
        cropState.dragging = false;
        cropState.resizing = false;
      }

      // Bind events
      imageWrap.addEventListener('mousedown', onStart);
      imageWrap.addEventListener('touchstart', onStart, { passive: false });
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);

      cancelBtn.onclick = function () { cleanup(); };

      confirmBtn.onclick = function () {
        // Calculate crop in original image coordinates
        var imgRect = cropImg.getBoundingClientRect();
        var scaleX = cropImg.naturalWidth / imgRect.width;
        var scaleY = cropImg.naturalHeight / imgRect.height;
        var cx = Math.round(cropState.sx * scaleX);
        var cy = Math.round(cropState.sy * scaleY);
        var cw = Math.round(cropState.sw * scaleX);
        var ch = Math.round(cropState.sh * scaleY);

        // Canvas crop — use the already-loaded cropImg directly (no CORS issues)
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        try {
          ctx.drawImage(cropImg, cx, cy, cw, ch, 0, 0, cw, ch);
          canvas.toBlob(function (blob) {
            if (!blob) { showUploadError('Zuschneiden fehlgeschlagen.'); cleanup(); return; }
            var croppedFile = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
            cleanup();
            uploadFile(croppedFile);
          }, 'image/jpeg', 0.92);
        } catch (err) {
          showUploadError('Zuschneiden fehlgeschlagen.');
          cleanup();
        }
      };
    }

    /**
     * Firebase upload via REST API with Auth + App Check tokens.
     * App Check (reCAPTCHA v3) is REQUIRED by Firebase Storage rules.
     * Same approach as useImageUpload.ts in designer-studio.
     */
    var firebaseInitPromise = null;
    var cachedFirebaseApp = null;
    var cachedAppCheck = null;
    var cachedBucket = null;

    function initFirebase() {
      if (firebaseInitPromise) return firebaseInitPromise;

      firebaseInitPromise = Promise.resolve()
        .then(function () {
          // Read Firebase config from inline JSON in Liquid template (no network request needed)
          var configEl = document.getElementById('frame-firebase-config');
          if (!configEl) throw new Error('Firebase config element #frame-firebase-config not found');

          var config = JSON.parse(configEl.textContent);
          if (!config.firebase || !config.firebase.apiKey) {
            throw new Error('Invalid Firebase config in #frame-firebase-config');
          }

          cachedBucket = config.firebase.storageBucket;
          var recaptchaSiteKey = config.recaptcha && config.recaptcha.siteKey;

          // Initialize Firebase app (compat SDK)
          if (!firebase.apps.length) {
            cachedFirebaseApp = firebase.initializeApp(config.firebase);
          } else {
            cachedFirebaseApp = firebase.apps[0];
          }

          // Initialize App Check with reCAPTCHA v3 (REQUIRED before Storage upload)
          if (recaptchaSiteKey && !cachedAppCheck) {
            console.log('[FrameConfigurator] Initializing App Check with reCAPTCHA v3...');
            cachedAppCheck = firebase.appCheck(cachedFirebaseApp);
            cachedAppCheck.activate(
              new firebase.appCheck.ReCaptchaV3Provider(recaptchaSiteKey),
              true // isTokenAutoRefreshEnabled
            );
          } else if (!recaptchaSiteKey) {
            console.warn('[FrameConfigurator] No reCAPTCHA site key — App Check will not be initialized');
          }

          // Sign in anonymously
          console.log('[FrameConfigurator] Signing in anonymously...');
          return firebase.auth(cachedFirebaseApp).signInAnonymously();
        })
        .then(function (userCredential) {
          console.log('[FrameConfigurator] Auth ready, uid:', userCredential.user.uid);
          // Get both Auth token and App Check token
          var authTokenPromise = userCredential.user.getIdToken(true);
          var appCheckTokenPromise = cachedAppCheck
            ? cachedAppCheck.getToken(false).then(function (result) { return result.token; })
            : Promise.resolve(null);

          return Promise.all([authTokenPromise, appCheckTokenPromise]);
        })
        .then(function (tokens) {
          console.log('[FrameConfigurator] Tokens ready — auth:', tokens[0].length, 'appCheck:', tokens[1] ? tokens[1].length : 'none');
          return { authToken: tokens[0], appCheckToken: tokens[1], bucket: cachedBucket };
        })
        .catch(function (err) {
          firebaseInitPromise = null;
          throw err;
        });

      return firebaseInitPromise;
    }

    /**
     * Get fresh tokens for upload
     */
    function getFreshTokens() {
      var user = cachedFirebaseApp && firebase.auth(cachedFirebaseApp).currentUser;
      if (user) {
        var authP = user.getIdToken(false);
        var appCheckP = cachedAppCheck
          ? cachedAppCheck.getToken(false).then(function (r) { return r.token; })
          : Promise.resolve(null);
        return Promise.all([authP, appCheckP]).then(function (t) {
          return { authToken: t[0], appCheckToken: t[1], bucket: cachedBucket };
        });
      }
      firebaseInitPromise = null;
      return initFirebase();
    }

    /**
     * Handle file upload: validate → local preview → Firebase REST upload → update SVG
     */
    function uploadFile(file) {
      if (!file) return;

      // Validation
      var MAX_SIZE = 25 * 1024 * 1024; // 25 MB
      var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showUploadError('Nur JPG, PNG oder WebP Dateien erlaubt.');
        return;
      }
      if (file.size > MAX_SIZE) {
        showUploadError('Datei zu gro\u00DF (max. 25 MB).');
        return;
      }

      // Revoke previous blob URL to prevent memory leaks
      if (state.localBlobUrl) {
        URL.revokeObjectURL(state.localBlobUrl);
      }

      // Instant local preview via blob URL — keep blob URL for rotate/crop (CORS-safe)
      var localUrl = URL.createObjectURL(file);
      state.localBlobUrl = localUrl;
      state.imageUrl = localUrl;
      _userHasConfigured = true;
      saveImageToIDB(file);
      renderPreview();
      scrollGalleryToPreview();
      // Reorder gallery: show 2nd product image first when customer has uploaded
      reorderDesktopGallerySlides();
      reorderMobileGallerySlides();
      refreshGalleryAfterReorder();
      showUploadProgress(0);

      // Read image aspect ratio for auto-dimension calculation
      var arImg = new Image();
      arImg.onload = function () {
        if (arImg.naturalWidth && arImg.naturalHeight) {
          state.imageAspectRatio = arImg.naturalWidth / arImg.naturalHeight;
          // Auto-set height from current width
          if (isAutoAspectType()) {
            var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
            autoH = Math.max(10, Math.min(110, autoH));
            state.imageHeight = autoH;
            if (heightInput) { heightInput.value = autoH; }
            debouncedUpdate();
          }
        }
      };
      arImg.src = localUrl;

      var timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      var randomId = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      var ext = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
      var filename = 'processed-' + timestamp + '-' + randomId + '.' + ext;
      var storagePath = 'uploads/' + filename;

      console.log('[FrameConfigurator] Starting Firebase upload for', filename);

      initFirebase()
        .then(function () {
          // Always get fresh tokens right before upload
          return getFreshTokens();
        })
        .then(function (result) {
          var authToken = result.authToken;
          var appCheckToken = result.appCheckToken;
          var bucket = result.bucket;

          // Upload via Firebase Storage REST API with explicit tokens
          var uploadUrl = 'https://firebasestorage.googleapis.com/v0/b/' +
            encodeURIComponent(bucket) + '/o?uploadType=media&name=' +
            encodeURIComponent(storagePath);

          console.log('[FrameConfigurator] Uploading with Auth + AppCheck tokens...');

          return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', uploadUrl);
            xhr.setRequestHeader('Authorization', 'Bearer ' + authToken);
            xhr.setRequestHeader('Content-Type', file.type);
            // App Check token header — required by Firebase Storage
            if (appCheckToken) {
              xhr.setRequestHeader('X-Firebase-AppCheck', appCheckToken);
            }

            xhr.upload.onprogress = function (ev) {
              if (ev.lengthComputable) {
                showUploadProgress((ev.loaded / ev.total) * 100);
              }
            };

            xhr.onload = function () {
              if (xhr.status === 200) {
                try {
                  var data = JSON.parse(xhr.responseText);
                  // Build the download URL from the response
                  var downloadUrl = 'https://firebasestorage.googleapis.com/v0/b/' +
                    encodeURIComponent(bucket) + '/o/' +
                    encodeURIComponent(data.name) +
                    '?alt=media&token=' + (data.downloadTokens || '');
                  resolve(downloadUrl);
                } catch (e) {
                  reject(new Error('Failed to parse upload response'));
                }
              } else {
                console.error('[FrameConfigurator] Upload response:', xhr.status, xhr.responseText);
                reject(new Error('Upload failed (status ' + xhr.status + ')'));
              }
            };

            xhr.onerror = function () {
              reject(new Error('Network error during upload'));
            };

            // Send the raw file bytes
            xhr.send(file);
          });
        })
        .then(function (downloadUrl) {
          console.log('[FrameConfigurator] Upload complete:', downloadUrl);
          state.imageUrl = downloadUrl;
          // DO NOT revoke localUrl — kept as state.localBlobUrl for rotate/crop (CORS-safe)
          // Persist Firebase URL in IndexedDB (blob already saved during upload start)
          saveImageToIDB(null, downloadUrl);
          showUploadPreview(downloadUrl);
          renderPreview();
        })
        .catch(function (err) {
          console.error('[FrameConfigurator] Upload error:', err.message || err);
          showUploadError('Upload fehlgeschlagen. Bild wird nur lokal angezeigt.');
          showUploadPreview(localUrl);
        });
    }

    /* --- DIMENSION VALIDATION --- */

    function validateDimensions() {
      var errors = [];
      var w = state.imageWidth;
      var h = state.imageHeight;

      if (w < 10) errors.push('Mindestbreite: 10 cm');
      if (h < 10) errors.push('Mindesthoehe: 10 cm');
      if (w > 110) errors.push('Maximale Breite: 110 cm');
      if (h > 110) errors.push('Maximale H\u00f6he: 110 cm');
      if (w > 90 && h > 90 && w <= 110 && h <= 110) {
        errors.push('Eine Seite darf maximal 110 cm und die andere maximal 90 cm betragen (max. 90 \u00d7 110 bzw. 110 \u00d7 90)');
      }

      if (dimensionsError) {
        if (errors.length > 0) {
          dimensionsError.textContent = errors.join('. ') + '.';
          dimensionsError.style.display = '';
        } else {
          dimensionsError.textContent = '';
          dimensionsError.style.display = 'none';
        }
      }

      if (widthInput) widthInput.classList.toggle('fc-input--error', w > 110 || (w > 90 && h > 90));
      if (heightInput) heightInput.classList.toggle('fc-input--error', h > 110 || (w > 90 && h > 90));

      return errors.length === 0;
    }

    /* --- OUTER DIMENSION HELPERS --- */

    function calculateOuterDimensions(imgW, imgH, matTopCM, matBottomCM, matLeftRightCM) {
      var frameWidthCM = productData.frameBreiteMM / 10;
      var frameHeightCM = (productData.frameHoeheMM || productData.frameBreiteMM) / 10;
      return {
        width: imgW + 2 * matLeftRightCM + 2 * frameWidthCM,
        height: imgH + matTopCM + matBottomCM + 2 * frameHeightCM
      };
    }

    function fitsOuterLimit(outerW, outerH) {
      if (outerW > 110 || outerH > 110) return false;
      if (outerW > 90 && outerH > 90) return false;
      return true;
    }

    /* --- CORE UPDATE --- */

    function update() {
      // Validate dimensions — do NOT clamp silently
      var dimensionsValid = validateDimensions();

      // For internal calculations, use clamped values
      var calcWidth = Math.max(10, Math.min(110, state.imageWidth));
      var calcHeight = Math.max(10, Math.min(110, state.imageHeight));
      if (calcWidth > 90 && calcHeight > 90) {
        calcHeight = 90;
      }

      var sizeCategory = getSizeCategory(
        calcWidth, calcHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );

      var variant = lookupVariant(variantIndex, state.frameType, sizeCategory, state.ppType);
      state.currentVariant = dimensionsValid ? variant : null;
      state.currentPrice = variant ? variant.price : null;

      sizeCategoryEl.textContent = sizeCategory;
      priceEl.textContent = variant ? formatPriceFromEuros(variant.price) : '\u2013';
      var isSendIn = normalizeTypeKey(state.frameType).indexOf('digital') === -1;
      var deliveryInfo = getDeliveryEstimate(isSendIn);
      if (deliveryEl) deliveryEl.textContent = deliveryInfo.headline.replace('Voraussichtliche Lieferung: ', '');
      if (deliveryHeadlineEl) deliveryHeadlineEl.textContent = deliveryInfo.headline;
      if (deliverySendinEl) {
        if (deliveryInfo.sendin) {
          deliverySendinEl.textContent = deliveryInfo.sendin;
          deliverySendinEl.style.display = '';
        } else {
          deliverySendinEl.style.display = 'none';
        }
      }
      dimensionsHint.textContent = state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm';

      // Calculate and display overall frame size (Gesamtgröße)
      if (overallSizeEl) {
        if (dimensionsValid) {
          var oMatTop = 0, oMatBottom = 0, oMatLR = 0;
          if (state.ppType !== 'ohne') {
            if (state.matWidth === 'individual') {
              oMatTop = state.individualSizes.top || 0;
              oMatBottom = state.individualSizes.bottom || 0;
              oMatLR = state.individualSizes.leftRight || 0;
            } else {
              var oPreset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth];
              if (oPreset) { oMatTop = oPreset.top; oMatBottom = oPreset.bottom; oMatLR = oPreset.leftRight; }
            }
          }
          var outer = calculateOuterDimensions(state.imageWidth, state.imageHeight, oMatTop, oMatBottom, oMatLR);
          overallSizeEl.textContent = Math.round(outer.width * 10) / 10 + ' \u00D7 ' + Math.round(outer.height * 10) / 10 + ' cm';
        } else {
          overallSizeEl.textContent = '\u2013';
        }
      }

      if (state.ppType !== 'ohne') {
        ppWidthHint.textContent = state.matWidth === 'individual'
          ? state.individualSizes.top + ' / ' + state.individualSizes.bottom + ' / ' + state.individualSizes.leftRight + ' cm'
          : getMatPresetDescription(state.matWidth);
      } else {
        ppWidthHint.textContent = '';
      }

      var uploadMissing = isUploadRequired() && !state.imageUrl;
      atcButton.disabled = !dimensionsValid || !variant || uploadMissing;

      // Update upload label based on frame type and upload state
      if (uploadGroupLabel) {
        if (state.imageUrl) {
          // Image uploaded — no badge needed
          uploadGroupLabel.innerHTML = 'Dein Bild';
          if (uploadGroup) uploadGroup.classList.remove('fc-upload--missing');
        } else if (isUploadRequired()) {
          uploadGroupLabel.innerHTML = 'Dein Bild <span class="fc-required-badge">Ben\u00f6tigt</span>';
          if (uploadGroup) uploadGroup.classList.toggle('fc-upload--missing', uploadMissing);
        } else {
          uploadGroupLabel.innerHTML = 'Dein Bild';
          if (uploadGroup) uploadGroup.classList.remove('fc-upload--missing');
        }
      }

      // Sync mobile info bar price
      if (mobileInfoPrice) mobileInfoPrice.textContent = variant ? formatPriceFromEuros(variant.price) : '\u2013';

      if (!variant) {
        console.log('[FrameConfigurator] No variant found for:', state.frameType, '|', sizeCategory, '|', state.ppType);
      }

      // Variant availability hint — show helpful message when no variant found
      if (variantHintEl) {
        if (!variant && dimensionsValid) {
          var hint = getVariantHint(variantIndex, state.frameType, sizeCategory,
            state.ppType, state.imageWidth, state.imageHeight, productData.frameBreiteMM);
          if (hint) {
            variantHintEl.textContent = hint;
            variantHintEl.style.display = '';
          } else {
            variantHintEl.style.display = 'none';
          }
        } else {
          variantHintEl.style.display = 'none';
        }
      }

      // Update page-level price display (configurator page — show current price, not "ab")
      var pagePriceSpan = document.querySelector('#fc-page-price .price-item--regular');
      if (pagePriceSpan) {
        pagePriceSpan.textContent = state.currentPrice ? formatPriceFromEuros(state.currentPrice) : '\u2013';
      }

      renderPreview();
      updateAvailability();
      updatePPStepVisibility();
      renderProductSwitcher();
      renderTypeCards();
      updateStepSubtitles();

      // Sync URL with current state so a page refresh restores the configuration
      if (_initialized) {
        var variantId = state.currentVariant ? state.currentVariant.id : null;
        var urlParams = buildStateParams(productData.handle, variantId);
        if (isProductPage) urlParams.delete('product');
        var newUrl = window.location.pathname + '?' + urlParams.toString();
        if (newUrl !== window.location.pathname + window.location.search) {
          window.history.replaceState({}, '', newUrl);
        }

        // Re-check favorite state: config changed → heart should reflect new configUrl
        if (typeof window.FramelinFavorites !== 'undefined') {
          var currentConfigUrl = buildConfigUrl();
          window.FramelinFavorites.isFavorited(currentConfigUrl)
            .then(function (favorited) {
              setFavoriteButtonState(favorited);
            })
            .catch(function () { /* ignore */ });
        }
      }
    }

    /* --- TYPE SWITCH HELPER (lazy variant loading) --- */

    /**
     * Handle a frame type switch. If the selected type has no variant data
     * (truncated product), show a loading state and lazy-fetch all variants
     * via Storefront API before updating.
     */
    function handleTypeSwitch(newType) {
      state.frameType = newType;

      // Adjust dimensions from aspect ratio before update
      if (isAutoAspectType() && state.imageAspectRatio) {
        var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
        autoH = Math.max(10, Math.min(110, autoH));
        state.imageHeight = autoH;
        if (heightInput) { heightInput.value = autoH; }
      }

      // Lazy-load: if this type has no variant data AND we have a Storefront API token
      if (!variantIndex[newType] && storefrontConfig.token && !allProductVariantIndexes[productData.handle + '__full']) {
        var fetchHandle = productData.handle;

        // Show loading state
        priceEl.textContent = 'Lade Preise\u2026';
        if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
        atcButton.disabled = true;
        renderTypeCards(); // re-render to show new selection immediately

        lazyFetchVariants(fetchHandle, productData.productId, function (newIndex) {
          // Guard: only apply if user hasn't switched products
          if (productData.handle !== fetchHandle) return;
          variantIndex = newIndex;
          productIsTruncated = false; // all types now have data
          update();
        });
      } else {
        update();
      }
    }

    /* --- EVENT HANDLERS (registered BEFORE first update) --- */

    ppTypeOptions.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-type]');
      if (!btn) return;
      setActiveButton(ppTypeOptions, btn);
      state.ppType = btn.dataset.ppType;
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      togglePPOptions();
      update();
    });

    /* --- Passepartout Info Panel --- */
    (function () {
      var infoBtn = document.getElementById('fc-pp-type-info-btn');
      var infoPanel = document.getElementById('fc-pp-type-info-panel');
      var infoOverlay = document.getElementById('fc-pp-type-info-overlay');
      var infoClose = document.getElementById('fc-pp-type-info-close');
      if (!infoBtn || !infoPanel) return;

      function openPanel() {
        infoPanel.classList.add('is-open');
        infoPanel.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closePanel() {
        infoPanel.classList.remove('is-open');
        infoPanel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel();
      });
      if (infoClose) infoClose.addEventListener('click', closePanel);
      if (infoOverlay) infoOverlay.addEventListener('click', closePanel);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && infoPanel.classList.contains('is-open')) closePanel();
      });
    })();

    ppWidthOptions.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-width]');
      if (!btn) return;
      setActiveButton(ppWidthOptions, btn);
      state.matWidth = btn.dataset.ppWidth;
      toggleIndividualInputs();
      update();
    });

    ppColorGrid.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-mat-color]');
      if (!swatch) return;
      setActiveSwatch(ppColorGrid, swatch);
      state.matColor = swatch.dataset.matColor;
      ppColorHint.textContent = swatch.dataset.matDisplayName || '';
      update();
    });

    if (typeCardsContainer) {
      typeCardsContainer.addEventListener('click', function (e) {
        var card = e.target.closest('.fc-type-card');
        if (!card || !card.dataset.typeValue) return;
        toggleStep('size');
        handleTypeSwitch(card.dataset.typeValue);
      });

      // Keyboard support: arrow keys for radiogroup pattern
      typeCardsContainer.addEventListener('keydown', function (e) {
        var cards = typeCardsContainer.querySelectorAll('.fc-type-card');
        if (!cards.length) return;
        var currentIndex = -1;
        for (var ci = 0; ci < cards.length; ci++) {
          if (cards[ci].classList.contains('fc-type-card--selected')) {
            currentIndex = ci;
            break;
          }
        }
        var newIndex = currentIndex;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          newIndex = (currentIndex + 1) % cards.length;
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = (currentIndex - 1 + cards.length) % cards.length;
        }
        if (newIndex !== currentIndex && cards[newIndex]) {
          cards[newIndex].focus();
          handleTypeSwitch(cards[newIndex].dataset.typeValue);
        }
      });
    }

    // Cross-link trigger: toggle expand/collapse
    if (crossLinkTrigger) {
      crossLinkTrigger.addEventListener('click', function () {
        var isOpen = crossLinkCards.style.display !== 'none';
        crossLinkCards.style.display = isOpen ? 'none' : '';
        crossLinkTrigger.classList.toggle('fc-cross-link__trigger--open', !isOpen);
      });
    }

    // Cross-link card click: navigate to counterpart product
    if (crossLinkCards) {
      crossLinkCards.addEventListener('click', function (e) {
        var card = e.target.closest('[data-cross-type]');
        if (!card) return;
        var targetHandle = card.dataset.crossHandle;
        var targetType = card.dataset.crossType;
        if (isProductPage || isConfiguratorPage) {
          // Set frameType in URL so switchProduct picks it up
          var params = new URLSearchParams(window.location.search);
          params.set('frameType', targetType);
          params.delete('variant');
          if (isProductPage) {
            params.delete('product');
            window.history.pushState({ fcHandle: targetHandle }, '', '/products/' + targetHandle + '?' + params.toString());
          } else {
            params.set('product', targetHandle);
            window.history.pushState({ fcHandle: targetHandle }, '', window.location.pathname + '?' + params.toString());
          }
          switchProduct(targetHandle);
        }
      });
    }

    if (productCardsEl) {
      // Swatch click → switch product
      productCardsEl.addEventListener('click', function (e) {
        var swatch = e.target.closest('.fc-frame-swatch');
        if (swatch && swatch.dataset.handle) {
          switchProduct(swatch.dataset.handle);
          return;
        }
        // Filter tab click
        var tab = e.target.closest('.fc-frame-tab');
        if (tab && tab.dataset.filter) {
          _activeFilterTab = tab.dataset.filter;
          // Update tab active states
          var tabs = productCardsEl.querySelectorAll('.fc-frame-tab');
          for (var i = 0; i < tabs.length; i++) {
            tabs[i].classList.toggle('fc-frame-tab--active', tabs[i].dataset.filter === _activeFilterTab);
          }
          // Filter swatches
          var swatches = productCardsEl.querySelectorAll('.fc-frame-swatch');
          for (var i = 0; i < swatches.length; i++) {
            var s = swatches[i];
            var colors = (s.dataset.colors || '').split(',');
            if (_activeFilterTab === 'Alle' || colors.indexOf(_activeFilterTab) !== -1) {
              s.classList.remove('fc-frame-swatch--hidden');
            } else {
              s.classList.add('fc-frame-swatch--hidden');
            }
          }
        }
      });
      // Swatch hover → show tooltip with frame name
      productCardsEl.addEventListener('mouseover', function (e) {
        var swatch = e.target.closest('.fc-frame-swatch');
        if (swatch && swatch.dataset.title) {
          swatch.title = swatch.dataset.title;
        }
      });
    }

    var debouncedUpdate = debounce(update, 200);

    widthInput.addEventListener('input', function () {
      state.imageWidth = parseFloat(widthInput.value) || 10;
      // Auto-calculate height from aspect ratio
      if (state.imageAspectRatio && isAutoAspectType()) {
        var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
        autoH = Math.max(10, Math.min(110, autoH));
        state.imageHeight = autoH;
        if (heightInput) heightInput.value = autoH;
      }
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      debouncedUpdate();
    });

    heightInput.addEventListener('input', function () {
      state.imageHeight = parseFloat(heightInput.value) || 10;
      // Auto-calculate width from aspect ratio
      if (state.imageAspectRatio && isAutoAspectType()) {
        var autoW = Math.round(state.imageHeight * state.imageAspectRatio);
        autoW = Math.max(10, Math.min(110, autoW));
        state.imageWidth = autoW;
        if (widthInput) widthInput.value = autoW;
      }
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      debouncedUpdate();
    });

    var matTopInput = document.getElementById('fc-mat-top');
    var matBottomInput = document.getElementById('fc-mat-bottom');
    var matSidesInput = document.getElementById('fc-mat-sides');

    [matTopInput, matBottomInput, matSidesInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        state.individualSizes = {
          top: parseFloat(matTopInput.value) || 2,
          bottom: parseFloat(matBottomInput.value) || 2,
          leftRight: parseFloat(matSidesInput.value) || 2
        };
        debouncedUpdate();
      });
    });

    /* --- UPLOAD EVENT HANDLERS --- */

    if (uploadDropzone && uploadInput) {
      // Click on dropzone opens file dialog
      uploadDropzone.addEventListener('click', function (e) {
        // Don't open dialog when clicking action buttons
        if (e.target.closest('.fc-upload__action-btn')) return;
        uploadInput.click();
      });

      // File input change
      uploadInput.addEventListener('change', function () {
        var file = uploadInput.files && uploadInput.files[0];
        if (file) uploadFile(file);
      });

      // Drag & Drop
      uploadDropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.add('fc-upload__dropzone--dragover');
      });

      uploadDropzone.addEventListener('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.remove('fc-upload__dropzone--dragover');
      });

      uploadDropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.remove('fc-upload__dropzone--dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) uploadFile(file);
      });

      // Change button — re-opens file dialog
      if (uploadChangeBtn) {
        uploadChangeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          uploadInput.click();
        });
      }

      // Remove button — clears image and resets upload UI
      if (uploadRemoveBtn) {
        uploadRemoveBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          state.imageUrl = null;
          resetUploadUI();
          // Restore original image order (1st product image back to front)
          reorderDesktopGallerySlides();
          reorderMobileGallerySlides();
          refreshGalleryAfterReorder();
          update();
        });
      }

      // Rotate button — rotates image 90° clockwise via canvas
      if (uploadRotateBtn) {
        uploadRotateBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          // Prefer localBlobUrl (CORS-safe) over Firebase HTTPS URL
          var srcUrl = state.localBlobUrl || state.imageUrl;
          if (!srcUrl) return;
          var img = new Image();
          // Only set crossOrigin for HTTP URLs, not for blob: URLs
          if (srcUrl.indexOf('blob:') !== 0) {
            img.crossOrigin = 'anonymous';
          }
          img.onerror = function () {
            showUploadError('Bild konnte nicht gedreht werden.');
          };
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = img.naturalHeight;
            canvas.height = img.naturalWidth;
            var ctx = canvas.getContext('2d');
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(Math.PI / 2);
            ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
            try {
              canvas.toBlob(function (blob) {
                if (!blob) { showUploadError('Drehen fehlgeschlagen.'); return; }
                var rotatedFile = new File([blob], 'rotated.jpg', { type: 'image/jpeg' });
                if (state.imageAspectRatio) {
                  state.imageAspectRatio = 1 / state.imageAspectRatio;
                }
                uploadFile(rotatedFile);
              }, 'image/jpeg', 0.92);
            } catch (err) {
              showUploadError('Drehen fehlgeschlagen.');
            }
          };
          img.src = srcUrl;
        });
      }

      // Crop button — opens crop overlay modal
      if (uploadCropBtn) {
        uploadCropBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          // Prefer localBlobUrl (CORS-safe) over Firebase HTTPS URL
          var srcUrl = state.localBlobUrl || state.imageUrl;
          if (!srcUrl) return;
          openCropOverlay(srcUrl);
        });
      }
    }

    /* --- UPLOAD BUTTON HANDLER --- */
    if (uploadBtn && uploadInput) {
      uploadBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        uploadInput.click();
      });
    }

    /* --- VIEW TOGGLE HANDLER (scroll ↔ grid) --- */
    if (viewToggle && productCardsEl) {
      viewToggle.addEventListener('click', function () {
        var isScroll = productCardsEl.classList.contains('fc-product-cards--scroll');
        productCardsEl.classList.toggle('fc-product-cards--scroll', !isScroll);
        productCardsEl.classList.toggle('fc-product-cards--grid', isScroll);
        setTimeout(updateScrollArrows, 50);
      });
    }

    /* --- SCROLL ARROWS FOR PRODUCT CARDS --- */
    var arrowPrev = document.getElementById('fc-cards-arrow-prev');
    var arrowNext = document.getElementById('fc-cards-arrow-next');

    function updateScrollArrows() {
      if (!productCardsEl || !arrowPrev || !arrowNext) return;
      var isScrollMode = productCardsEl.classList.contains('fc-product-cards--scroll');
      if (!isScrollMode) {
        arrowPrev.hidden = true;
        arrowNext.hidden = true;
        return;
      }
      var scrollLeft = productCardsEl.scrollLeft;
      var maxScroll = productCardsEl.scrollWidth - productCardsEl.clientWidth;
      arrowPrev.hidden = scrollLeft <= 2;
      arrowNext.hidden = maxScroll <= 2 || scrollLeft >= maxScroll - 2;
    }

    if (productCardsEl && arrowPrev && arrowNext) {
      productCardsEl.addEventListener('scroll', debounce(updateScrollArrows, 100));
      window.addEventListener('resize', debounce(updateScrollArrows, 200));

      arrowPrev.addEventListener('click', function () {
        productCardsEl.scrollBy({ left: -220, behavior: 'smooth' });
      });
      arrowNext.addEventListener('click', function () {
        productCardsEl.scrollBy({ left: 220, behavior: 'smooth' });
      });

      // Observe size changes so arrows update when cards render or images load
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(debounce(updateScrollArrows, 50)).observe(productCardsEl);
      }
    }

    /* --- SUSPENSION EVENT HANDLERS --- */
    if (suspensionOptions) {
      suspensionOptions.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-suspension]');
        if (!btn || btn.disabled) return;
        setActiveButton(suspensionOptions, btn);
        state.suspension = btn.dataset.suspension;
        if (suspensionHint) {
          suspensionHint.textContent = SUSPENSION_INFO[state.suspension] || '';
        }
        updateStepSubtitles();
      });
    }

    atcButton.addEventListener('click', addToCart);

    /* --- MOBILE STICKY ELEMENTS SETUP --- */

    // Measure header height and set CSS variable for split-screen layout
    function setHeaderHeight() {
      var header = document.querySelector('sticky-header');
      var h = header ? header.offsetHeight : 68;
      document.documentElement.style.setProperty('--fc-header-height', h + 'px');
    }
    setHeaderHeight();
    if (isMobileQuery.matches) {
      // Also trigger initial mobile preview sync
      updateMobilePreview();
    }
    window.addEventListener('resize', debounce(setHeaderHeight, 200));

    // Keep header always visible on configurator page (disable hide-on-scroll)
    (function () {
      var stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      // Remove the scroll handler that hides/shows the header
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
      }
      // Ensure header stays in sticky-visible state
      stickyHeader.classList.remove('shopify-section-header-hidden');
      stickyHeader.classList.add('shopify-section-header-sticky');
      // Prevent future hide calls
      stickyHeader.hide = function () {};
    })();

    /* --- ADD TO CART --- */

    function addToCart() {
      if (!state.currentVariant) return;

      // Check required upload
      if (isUploadRequired() && !state.imageUrl) {
        atcError.textContent = 'Bitte lade zuerst dein Bild hoch.';
        atcError.style.display = '';
        if (uploadGroup) {
          uploadGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          uploadGroup.classList.add('fc-upload--missing');
        }
        return;
      }

      var variant = state.currentVariant;
      atcButton.disabled = true;
      atcButton.querySelector('.fc-atc__text').style.display = 'none';
      atcButton.querySelector('.fc-atc__loading').style.display = '';
      atcError.style.display = 'none';

      var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

      var susLabel = state.suspension === 'wallbuddies' ? 'Wall Buddies' : (state.suspension.charAt(0).toUpperCase() + state.suspension.slice(1));

      var properties = {
        'Bildgr\u00f6\u00dfe': state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm',
        'Aufh\u00e4ngung': susLabel
      };

      if (state.ppType !== 'ohne') {
        properties['Passepartout-Farbe'] = matColorOption ? matColorOption.displayName : state.matColor;
        properties['Passepartout-Breite'] = state.matWidth === 'individual'
          ? state.individualSizes.top + ' / ' + state.individualSizes.bottom + ' / ' + state.individualSizes.leftRight + ' cm'
          : getMatPresetDescription(state.matWidth);
      }

      // Hidden properties for cart SVG rendering (prefixed with _ to hide from checkout)
      if (state.imageUrl) {
        properties['_imageUrl'] = state.imageUrl;
      }

      // SVG render data for cart preview (compact JSON, no mat_color_options to stay under 5000 char limit)
      var svgRenderPayload = {
        customer_image_url: state.imageUrl || null,
        frame_product_id: productData.productId,
        frame_name: productData.title,
        mat_color: state.matColor,
        mat_width: state.matWidth,
        rotation: 0,
        dimensions: { width: state.imageWidth, height: state.imageHeight },
        frame_texture_lr: productData.frameImageLR,
        frame_texture_tb: productData.frameImageTB,
        frame_width_mm: productData.frameBreiteMM,
        passepartout_type: state.ppType
      };
      if (matColorOption) {
        svgRenderPayload.mat_color_url = {
          url: matColorOption.imageUrl,
          color_key: matColorOption.color,
          display_name: matColorOption.displayName
        };
      }
      properties['_SVG-Render-Data'] = JSON.stringify(svgRenderPayload);

      var body = {
        items: [{
          id: variant.id,
          quantity: 1,
          properties: properties
        }]
      };

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || err.message || 'Fehler beim Hinzuf\u00fcgen');
          });
        }
        return response.json();
      })
      .then(function (data) {
        // Generate SVG markup for cart preview (same logic as renderPreview)
        var cartSvgMarkup = null;
        if (typeof window.generateFramePreviewSvg === 'function') {
          var cartMatType = 'none';
          if (state.ppType === 'einfach') cartMatType = 'standard';
          if (state.ppType === 'freigestellt') cartMatType = 'inner';
          var cartIndividualSizes = null;
          if (state.matWidth === 'individual') {
            cartIndividualSizes = {
              top: state.individualSizes.top,
              bottom: state.individualSizes.bottom,
              left: state.individualSizes.leftRight,
              right: state.individualSizes.leftRight
            };
          }
          try {
            cartSvgMarkup = window.generateFramePreviewSvg({
              imageUrl: state.imageUrl || '',
              frameConfig: {
                productId: productData.productId,
                frameImageLR: productData.frameImageLR || '',
                frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
                frameWidth: productData.frameBreiteMM || 24
              },
              matConfig: {
                type: cartMatType,
                width: state.matWidth,
                color: state.matColor,
                colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
                individualSizes: cartIndividualSizes
              },
              dimensions: { width: state.imageWidth, height: state.imageHeight },
              rotation: 0
            });
          } catch (svgErr) {
            console.warn('[FrameConfigurator] Could not generate cart SVG:', svgErr);
          }
        }

        // Persist cart SVG render data
        var lineItemKey = String(variant.id) + '-' + Date.now();
        persistCartSvgRenderData(lineItemKey, {
          customer_image_url: state.imageUrl || null,
          frame_product_id: productData.productId,
          frame_name: productData.title,
          mat_color: state.matColor,
          mat_width: state.matWidth,
          rotation: 0,
          dimensions: { width: state.imageWidth, height: state.imageHeight },
          frame_texture_lr: productData.frameImageLR,
          frame_texture_tb: productData.frameImageTB,
          frame_width_mm: productData.frameBreiteMM,
          mat_color_url: matColorOption
            ? { url: matColorOption.imageUrl, color_key: matColorOption.color, display_name: matColorOption.displayName }
            : { url: '', color_key: state.matColor, display_name: state.matColor },
          mat_color_options: SHARED_MAT_COLOR_OPTIONS,
          svg_html: null,
          svg_markup: cartSvgMarkup,
          passepartout_type: state.ppType
        });

        // Publish cart update for theme mini-cart (pubsub.js)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'frame-configurator',
            productVariantId: variant.id,
            cartData: data
          });
        }

        // Open mini-cart or redirect
        var miniCart = document.querySelector('mini-cart') || document.querySelector('cart-drawer');
        if (miniCart && miniCart.renderContents) {
          fetch(window.location.pathname + '?sections=mini-cart,cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) { miniCart.renderContents({ sections: sections }); })
            .catch(function () { window.location.href = root + 'cart'; });
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (err) {
        atcError.textContent = err.message || 'Ein Fehler ist aufgetreten.';
        atcError.style.display = '';
      })
      .finally(function () {
        atcButton.disabled = false;
        atcButton.querySelector('.fc-atc__text').style.display = '';
        atcButton.querySelector('.fc-atc__loading').style.display = 'none';
      });
    }

    /* --- INITIALIZATION (single path, no double update) --- */

    // 1. Render product switcher, type cards + mat color swatches
    renderProductSwitcher();
    // Ensure frame info box is populated even when product switcher is hidden (single product)
    updateFrameInfoBox(productData);
    renderTypeCards();
    renderMatColorSwatches();

    // 2. Read URL params and set state
    var params = new URLSearchParams(window.location.search);
    if (params.get('frameType')) {
      // Normalized match: "Leinwand nicht aufgespannt" matches "Leinwand (nicht aufgespannt)" etc.
      var urlTypeNorm = normalizeTypeKey(params.get('frameType'));
      var matchedType = null;
      for (var fti = 0; fti < frameTypeValues.length; fti++) {
        if (normalizeTypeKey(frameTypeValues[fti]) === urlTypeNorm) {
          matchedType = frameTypeValues[fti];
          break;
        }
      }
      if (matchedType) state.frameType = matchedType;
    }
    if (params.get('ppType')) state.ppType = params.get('ppType');
    if (params.get('matWidth')) state.matWidth = params.get('matWidth');
    if (params.get('matColor')) state.matColor = params.get('matColor');
    if (params.get('width')) state.imageWidth = parseFloat(params.get('width')) || 30;
    if (params.get('height')) state.imageHeight = parseFloat(params.get('height')) || 40;
    // Individual PP sizes from URL params (set during product switch)
    if (params.get('matTop')) {
      state.individualSizes.top = parseFloat(params.get('matTop')) || 5.5;
      state.individualSizes.bottom = parseFloat(params.get('matBottom')) || 6;
      state.individualSizes.leftRight = parseFloat(params.get('matSides')) || 5.5;
    }

    // 2b. Restore uploaded image from sessionStorage (set by switchProduct before navigation)
    try {
      var transferredImageUrl = sessionStorage.getItem('fc-transfer-imageUrl');
      if (transferredImageUrl) {
        sessionStorage.removeItem('fc-transfer-imageUrl');
        state.imageUrl = transferredImageUrl;
      }
    } catch (e) { /* sessionStorage not available */ }

    // 2c. Re-render type cards so the URL-param frameType is visually selected
    renderTypeCards();

    // 2d. Open type accordion if frameType was preselected via URL
    if (params.get('frameType') && typeGroup && typeGroup.style.display !== 'none') {
      toggleStep('type');
    }

    // 3. Sync UI to state
    syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
    syncButtonState(ppWidthOptions, 'data-pp-width', state.matWidth);
    togglePPOptions();
    toggleIndividualInputs();
    widthInput.value = state.imageWidth;
    heightInput.value = state.imageHeight;
    // Sync individual PP size inputs
    if (params.get('matTop')) {
      if (matTopInput) matTopInput.value = state.individualSizes.top;
      if (matBottomInput) matBottomInput.value = state.individualSizes.bottom;
      if (matSidesInput) matSidesInput.value = state.individualSizes.leftRight;
    }
    // Restore upload preview from sessionStorage or IndexedDB
    // sessionStorage is set during product switch OR favorites "Konfigurieren" click
    var _imageFromSessionStorage = false;
    if (state.imageUrl) {
      _userHasConfigured = true;
      _imageFromSessionStorage = true;
      showUploadPreview(state.imageUrl);
      // Reorder gallery for restored upload and scroll to SVG preview
      reorderDesktopGallerySlides();
      reorderMobileGallerySlides();
      refreshGalleryAfterReorder(true);
    }
    loadImageFromIDB(function (data) {
      // Restore Firebase URL from IndexedDB if not already set via sessionStorage
      if (!state.imageUrl && data.firebaseUrl) {
        _userHasConfigured = true;
        state.imageUrl = data.firebaseUrl;
        showUploadPreview(state.imageUrl);
        reorderDesktopGallerySlides();
        reorderMobileGallerySlides();
        refreshGalleryAfterReorder(true);
      }
      // Restore blob for CORS-safe rotate/crop
      if (data.blob) {
        if (state.localBlobUrl) URL.revokeObjectURL(state.localBlobUrl);
        state.localBlobUrl = URL.createObjectURL(data.blob);
        // If state.imageUrl is still empty, use blob URL for SVG rendering
        if (!state.imageUrl) {
          _userHasConfigured = true;
          state.imageUrl = state.localBlobUrl;
          reorderDesktopGallerySlides();
          reorderMobileGallerySlides();
          refreshGalleryAfterReorder(true);
        }
        // Only update thumbnail to IndexedDB blob if no image was passed via sessionStorage
        // (sessionStorage image = favorite's specific image, should not be overwritten)
        if (!_imageFromSessionStorage) {
          showUploadPreview(state.localBlobUrl);
        }
      }
      // Recalculate aspect ratio and re-render preview with restored image
      if (state.imageUrl || state.localBlobUrl) {
        var restoredImg = new Image();
        restoredImg.onload = function () {
          if (restoredImg.naturalWidth && restoredImg.naturalHeight) {
            state.imageAspectRatio = restoredImg.naturalWidth / restoredImg.naturalHeight;
            if (isAutoAspectType()) {
              var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
              autoH = Math.max(10, Math.min(110, autoH));
              state.imageHeight = autoH;
              if (heightInput) heightInput.value = autoH;
            }
          }
          // Always re-render after image restore (update() ran before IDB callback)
          update();
        };
        restoredImg.crossOrigin = 'anonymous';
        restoredImg.src = state.localBlobUrl || state.imageUrl;
      }
    });

    var activeSwatch = ppColorGrid.querySelector('[data-mat-color="' + state.matColor + '"]');
    if (activeSwatch) {
      setActiveSwatch(ppColorGrid, activeSwatch);
      ppColorHint.textContent = activeSwatch.dataset.matDisplayName || '';
    }

    // 4. Single initial update (triggers variant lookup + price + SVG preview)
    update();
    _initialized = true;

    // 4a. Proactive variant loading for initial product if truncated
    if (productIsTruncated && storefrontConfig.token && !allProductVariantIndexes[productData.handle + '__full']) {
      priceEl.textContent = 'Lade Preise\u2026';
      if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
      atcButton.disabled = true;
      var initHandle = productData.handle;
      lazyFetchVariants(initHandle, productData.productId, function (newIndex) {
        if (productData.handle !== initHandle) return;
        variantIndex = newIndex;
        productIsTruncated = false;
        update();
      });
    }

    // 4b. Populate mobile preview gallery with product images
    populateMobileGallery(productData.images);

    // 4c. Bind gallery thumbnails with user-click tracking
    reBindGalleryThumbnails();

    // 4d. On configurator page: if URL has ?product=handle different from current,
    //     switch to that product immediately (client-side, no flash)
    if (isConfiguratorPage && params.get('product') && params.get('product') !== productData.handle) {
      switchProduct(params.get('product'));
    }

    // 4e. On product page: update URL with current state params (for browser back/forward)
    if (isProductPage) {
      var initParams = buildStateParams(productData.handle, null);
      initParams.delete('product');
      window.history.replaceState({ fcHandle: productData.handle }, '', window.location.pathname + '?' + initParams.toString());
    }

    // 4f. Handle browser back/forward for client-side product switches
    if (isProductPage || isConfiguratorPage) {
      window.addEventListener('popstate', function (e) {
        var targetHandle = null;
        if (e.state && e.state.fcHandle) {
          targetHandle = e.state.fcHandle;
        } else if (isProductPage) {
          // Extract handle from URL path: /products/<handle>
          var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
          if (pathMatch) targetHandle = pathMatch[1];
        } else {
          // Configurator page: read from ?product= param
          var params = new URLSearchParams(window.location.search);
          targetHandle = params.get('product');
        }
        if (targetHandle && targetHandle !== productData.handle) {
          // Temporarily treat as configurator to avoid infinite pushState loop
          var _origHandle = productData.handle;
          // Direct call to switch without pushState (popstate already changed URL)
          var targetProduct = null;
          for (var i = 0; i < productsList.length; i++) {
            if (productsList[i].handle === targetHandle) {
              targetProduct = productsList[i];
              break;
            }
          }
          if (targetProduct) {
            // Perform the switch inline (same as switchProduct but skip pushState)
            productData.frameImageLR = targetProduct.frameImageLR;
            productData.frameImageTB = targetProduct.frameImageTB || targetProduct.frameImageLR;
            productData.frameBreiteMM = targetProduct.frameBreiteMM;
            productData.frameHoeheMM = targetProduct.frameHoeheMM;
            productData.title = targetProduct.title;
            productData.handle = targetHandle;
            productData.productId = targetProduct.productId;
            productData.url = targetProduct.url;
            productData.priceMin = targetProduct.priceMin;
            productData.options = targetProduct.options;
            variantIndex = allProductVariantIndexes[targetHandle] || variantIndex;

            var newTypeKeys = [];
            if (targetProduct.options && Array.isArray(targetProduct.options)) {
              for (var oi = 0; oi < targetProduct.options.length; oi++) {
                var optName = (targetProduct.options[oi].name || '').toLowerCase();
                if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
                  newTypeKeys = targetProduct.options[oi].values || [];
                  break;
                }
              }
            }
            if (newTypeKeys.length === 0) newTypeKeys = Object.keys(variantIndex);
            var switchTruncated = isProductTruncated(targetProduct.options, variantIndex);
            productIsTruncated = switchTruncated;
            if (switchTruncated && storefrontConfig.token) {
              newTypeKeys = sortTypeValues(newTypeKeys);
            } else {
              newTypeKeys = sortTypeValues(newTypeKeys.filter(function (tv) {
                return tv === '_default' || variantIndex[tv];
              }));
            }
            if (newTypeKeys.length > 0 && newTypeKeys[0] !== '_default') {
              frameTypeValues = newTypeKeys;
              allTypeValues = newTypeKeys.slice();
              if (frameTypeValues.indexOf(state.frameType) === -1) {
                state.frameType = frameTypeValues[0];
              }
              renderTypeCards();
            }
            update();
            if (switchTruncated && storefrontConfig.token && !allProductVariantIndexes[targetHandle + '__full']) {
              var fetchHandle = targetHandle;
              lazyFetchVariants(fetchHandle, targetProduct.productId, function (newIndex) {
                if (productData.handle !== fetchHandle) return;
                variantIndex = newIndex;
                productIsTruncated = false;
                update();
              });
            }
            updateFrameInfoBox(targetProduct);
            updatePageInfo(targetProduct);
            populateMobileGallery(targetProduct.images);
            if (mobilePreviewSlider) mobilePreviewSlider.scrollTo({ left: 0, behavior: 'instant' });
            _userClickedThumbnail = false;
            if (!state.imageUrl) {
              var firstImgSlide = document.querySelector('.fc-page-product-image');
              if (firstImgSlide) {
                var mediaGallery = document.querySelector('media-gallery');
                if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
                  mediaGallery.setActiveMedia(firstImgSlide.dataset.mediaId, false, false);
                }
              }
            } else {
              scrollGalleryToPreview();
            }
            refreshGalleryAfterReorder();
            // Re-render product switcher to update active swatch
            renderProductSwitcher();
          }
        }
      });
    }

    // 5. Start on first product image (SVG preview is last slide,
    //    shown automatically when user uploads or configures)

    // 6. Gallery dots — horizontal scroll indicators (retry until slider is ready)
    (function tryInitDots(attempts) {
      if (attempts > 10) return;
      var slider = document.querySelector('.product__media-list');
      if (slider && slider.querySelectorAll('.product__media-item').length > 1) {
        initGalleryDots();
      } else {
        setTimeout(function () { tryInitDots(attempts + 1); }, 500);
      }
    })(0);

    /* ===================================================================
     * FAVORITES — Heart button integration (inside init scope for state access)
     * =================================================================== */

    /**
     * Build the current frameSpec object for favorites storage.
     * Same structure as used in renderPreview().
     */
    function getCurrentFrameSpec() {
      var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

      var matType = 'none';
      if (state.ppType === 'einfach') matType = 'standard';
      if (state.ppType === 'freigestellt') matType = 'inner';

      var individualSizesForSpec = null;
      if (state.matWidth === 'individual') {
        individualSizesForSpec = {
          top: state.individualSizes.top,
          bottom: state.individualSizes.bottom,
          left: state.individualSizes.leftRight,
          right: state.individualSizes.leftRight
        };
      }

      return {
        imageUrl: state.imageUrl || '',
        frameConfig: {
          productId: productData.productId,
          frameImageLR: productData.frameImageLR || '',
          frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
          frameWidth: productData.frameBreiteMM || 24
        },
        matConfig: {
          type: matType,
          width: state.matWidth,
          color: state.matColor,
          colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
          individualSizes: individualSizesForSpec
        },
        dimensions: { width: state.imageWidth, height: state.imageHeight },
        rotation: 0
      };
    }

    function buildConfigUrl() {
      var params = buildStateParams(productData.handle, state.currentVariant ? state.currentVariant.id : null);
      return '/products/' + productData.handle + '?' + params.toString();
    }

    function handleFavoriteClick(btn) {
      if (typeof window.FramelinFavorites === 'undefined') {
        console.warn('[FrameConfigurator] FramelinFavorites not loaded');
        return;
      }

      btn.classList.add('fc-favorite-btn--saving');
      btn.disabled = true;

      // Build frameSpec, then resolve persistent image URL before saving
      var frameSpec = getCurrentFrameSpec();
      var imageUrl = frameSpec.imageUrl;

      // If imageUrl is a blob: URL, try to get the Firebase URL from IndexedDB instead
      function saveWithUrl(persistentUrl) {
        frameSpec.imageUrl = persistentUrl;

        var favoriteData = {
          productHandle: productData.handle,
          productTitle: productData.title,
          configUrl: buildConfigUrl(),
          frameSpec: frameSpec
        };

        window.FramelinFavorites.saveFavorite(favoriteData)
          .then(function () {
            setFavoriteButtonState(true);
            showFavoriteToast('Zu Favoriten hinzugef\u00fcgt!');
          })
          .catch(function (err) {
            if (err.message === 'duplicate') {
              showFavoriteToast('Bereits in deinen Favoriten.');
            } else {
              showFavoriteToast('Fehler beim Speichern. Bitte erneut versuchen.');
              console.warn('[FrameConfigurator] Save favorite error:', err);
            }
          })
          .finally(function () {
            btn.classList.remove('fc-favorite-btn--saving');
            btn.disabled = false;
          });
      }

      if (imageUrl && imageUrl.indexOf('blob:') === 0) {
        // Blob URL won't persist — try to get Firebase URL from IndexedDB
        loadImageFromIDB(function (data) {
          saveWithUrl(data.firebaseUrl || imageUrl);
        });
      } else {
        saveWithUrl(imageUrl);
      }
    }

    function setFavoriteButtonState(isFavorited) {
      var btns = document.querySelectorAll('.fc-favorite-btn');
      btns.forEach(function (btn) {
        if (isFavorited) {
          btn.classList.add('fc-favorite-btn--active');
          btn.setAttribute('aria-label', 'Aus Favoriten entfernen');
        } else {
          btn.classList.remove('fc-favorite-btn--active');
          btn.setAttribute('aria-label', 'Zu Favoriten hinzuf\u00fcgen');
        }
      });
    }

    function showFavoriteToast(message) {
      var existing = document.querySelector('.fc-favorite-toast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.className = 'fc-favorite-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      toast.offsetHeight;
      toast.classList.add('fc-favorite-toast--visible');
      setTimeout(function () {
        toast.classList.remove('fc-favorite-toast--visible');
        setTimeout(function () { toast.remove(); }, 300);
      }, 2500);
    }

    function initFavoriteButton() {
      var btns = document.querySelectorAll('.fc-favorite-btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleFavoriteClick(btn);
        });
      });

      if (btns.length > 0 && typeof window.FramelinFavorites !== 'undefined') {
        var configUrl = buildConfigUrl();
        window.FramelinFavorites.isFavorited(configUrl)
          .then(function (favorited) {
            if (favorited) setFavoriteButtonState(true);
          })
          .catch(function () { /* silently ignore */ });
      }
    }

    // Expose for external use
    window.getFrameConfiguratorState = function () {
      return {
        frameSpec: getCurrentFrameSpec(),
        configUrl: buildConfigUrl(),
        productHandle: productData.handle,
        productTitle: productData.title
      };
    };

    // 7. Favorites — heart button integration
    initFavoriteButton();

    console.log('[FrameConfigurator] Initialized successfully.');
  }

  /* ===================================================================
   * BOOTSTRAP
   * =================================================================== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
